import { ResponseContext, RequestContext, HttpFile } from '../http/http';
import { Configuration} from '../configuration'

import { AddAudienceRequest } from '../models/AddAudienceRequest';
import { AddCreativeRequest } from '../models/AddCreativeRequest';
import { AdvertisingPlatformServiceAddAccountRepRequest } from '../models/AdvertisingPlatformServiceAddAccountRepRequest';
import { AdvertisingPlatformServiceAddCommissionGroupRequest } from '../models/AdvertisingPlatformServiceAddCommissionGroupRequest';
import { AdvertisingPlatformServiceAddSalesRepRequest } from '../models/AdvertisingPlatformServiceAddSalesRepRequest';
import { AdvertisingPlatformServiceAddUserRequest } from '../models/AdvertisingPlatformServiceAddUserRequest';
import { AdvertisingPlatformServiceAppendOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceAppendOrderLineNoteRequest';
import { AdvertisingPlatformServiceBatchAddAudiencesRequest } from '../models/AdvertisingPlatformServiceBatchAddAudiencesRequest';
import { AdvertisingPlatformServiceBatchAddCreativesRequest } from '../models/AdvertisingPlatformServiceBatchAddCreativesRequest';
import { AdvertisingPlatformServiceBatchRemoveAudiencesRequest } from '../models/AdvertisingPlatformServiceBatchRemoveAudiencesRequest';
import { AdvertisingPlatformServiceBatchRemoveCreativesRequest } from '../models/AdvertisingPlatformServiceBatchRemoveCreativesRequest';
import { AdvertisingPlatformServiceCloneOrderLineRequest } from '../models/AdvertisingPlatformServiceCloneOrderLineRequest';
import { AdvertisingPlatformServiceCreateOrgNoteRequest } from '../models/AdvertisingPlatformServiceCreateOrgNoteRequest';
import { AdvertisingPlatformServiceDeactivateOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceDeactivateOrderLineNoteRequest';
import { AdvertisingPlatformServicePauseSchedulesRequest } from '../models/AdvertisingPlatformServicePauseSchedulesRequest';
import { AdvertisingPlatformServicePlaySchedulesRequest } from '../models/AdvertisingPlatformServicePlaySchedulesRequest';
import { AdvertisingPlatformServiceRemoveCommissionGroupRequest } from '../models/AdvertisingPlatformServiceRemoveCommissionGroupRequest';
import { AdvertisingPlatformServiceRemoveUserRequest } from '../models/AdvertisingPlatformServiceRemoveUserRequest';
import { AdvertisingPlatformServiceRetryReportRunRequest } from '../models/AdvertisingPlatformServiceRetryReportRunRequest';
import { AdvertisingPlatformServiceRunOneSubscriptionRequest } from '../models/AdvertisingPlatformServiceRunOneSubscriptionRequest';
import { AdvertisingPlatformServiceRunReportRequest } from '../models/AdvertisingPlatformServiceRunReportRequest';
import { AdvertisingPlatformServiceTriggerRouteRequest } from '../models/AdvertisingPlatformServiceTriggerRouteRequest';
import { AdvertisingPlatformServiceUpdateAssetRequest } from '../models/AdvertisingPlatformServiceUpdateAssetRequest';
import { AdvertisingPlatformServiceUpdateEmailMappingRequest } from '../models/AdvertisingPlatformServiceUpdateEmailMappingRequest';
import { AdvertisingPlatformServiceUpdateFTPRequest } from '../models/AdvertisingPlatformServiceUpdateFTPRequest';
import { AdvertisingPlatformServiceUpdateOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceUpdateOrderLineNoteRequest';
import { AdvertisingPlatformServiceUpdatePixelRequest } from '../models/AdvertisingPlatformServiceUpdatePixelRequest';
import { AdvertisingPlatformServiceUpdatePublisherRequest } from '../models/AdvertisingPlatformServiceUpdatePublisherRequest';
import { AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest } from '../models/AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest';
import { AdvertisingPlatformServiceUpdateRouteRequest } from '../models/AdvertisingPlatformServiceUpdateRouteRequest';
import { AdvertisingPlatformServiceUpdateRuleRequest } from '../models/AdvertisingPlatformServiceUpdateRuleRequest';
import { AdvertisingPlatformServiceUpdateRuleSetRequest } from '../models/AdvertisingPlatformServiceUpdateRuleSetRequest';
import { AdvertisingPlatformServiceUpdateSubscriptionRequest } from '../models/AdvertisingPlatformServiceUpdateSubscriptionRequest';
import { ApproveOrderLineRequest } from '../models/ApproveOrderLineRequest';
import { Apqsv1Checks } from '../models/Apqsv1Checks';
import { Apqsv1Dependency } from '../models/Apqsv1Dependency';
import { Apqsv1HealthCheck } from '../models/Apqsv1HealthCheck';
import { Apqsv1HealthCondition } from '../models/Apqsv1HealthCondition';
import { Apqsv1Miscellanea } from '../models/Apqsv1Miscellanea';
import { Apqsv1SystemStat } from '../models/Apqsv1SystemStat';
import { Billingservicev1Checks } from '../models/Billingservicev1Checks';
import { Billingservicev1CommissionGroup } from '../models/Billingservicev1CommissionGroup';
import { Billingservicev1Dependency } from '../models/Billingservicev1Dependency';
import { Billingservicev1HealthCheck } from '../models/Billingservicev1HealthCheck';
import { Billingservicev1HealthCondition } from '../models/Billingservicev1HealthCondition';
import { Billingservicev1Invoice } from '../models/Billingservicev1Invoice';
import { Billingservicev1InvoiceStatus } from '../models/Billingservicev1InvoiceStatus';
import { Billingservicev1ListInvoicesResponse } from '../models/Billingservicev1ListInvoicesResponse';
import { Billingservicev1Miscellanea } from '../models/Billingservicev1Miscellanea';
import { Billingservicev1Org } from '../models/Billingservicev1Org';
import { Billingservicev1SystemStat } from '../models/Billingservicev1SystemStat';
import { Billingservicev2Invoice } from '../models/Billingservicev2Invoice';
import { Billingservicev2InvoiceStatus } from '../models/Billingservicev2InvoiceStatus';
import { Billingservicev2ListInvoicesResponse } from '../models/Billingservicev2ListInvoicesResponse';
import { CPMContainsInformationRelatingToAClientCpmanization } from '../models/CPMContainsInformationRelatingToAClientCpmanization';
import { Campaignservicev1AdType } from '../models/Campaignservicev1AdType';
import { Campaignservicev1Audience } from '../models/Campaignservicev1Audience';
import { Campaignservicev1Campaign } from '../models/Campaignservicev1Campaign';
import { Campaignservicev1Checks } from '../models/Campaignservicev1Checks';
import { Campaignservicev1Creative } from '../models/Campaignservicev1Creative';
import { Campaignservicev1Dependency } from '../models/Campaignservicev1Dependency';
import { Campaignservicev1HealthCheck } from '../models/Campaignservicev1HealthCheck';
import { Campaignservicev1HealthCondition } from '../models/Campaignservicev1HealthCondition';
import { Campaignservicev1JobStatus } from '../models/Campaignservicev1JobStatus';
import { Campaignservicev1ListCampaignsResponse } from '../models/Campaignservicev1ListCampaignsResponse';
import { Campaignservicev1Miscellanea } from '../models/Campaignservicev1Miscellanea';
import { Campaignservicev1Note } from '../models/Campaignservicev1Note';
import { Campaignservicev1NoteType } from '../models/Campaignservicev1NoteType';
import { Campaignservicev1OrderLine } from '../models/Campaignservicev1OrderLine';
import { Campaignservicev1Status } from '../models/Campaignservicev1Status';
import { Campaignservicev1SystemStat } from '../models/Campaignservicev1SystemStat';
import { CancelOrderLineDeploymentRequest } from '../models/CancelOrderLineDeploymentRequest';
import { Contact } from '../models/Contact';
import { CreateCreditCardRequest } from '../models/CreateCreditCardRequest';
import { CreateDeploymentRequest } from '../models/CreateDeploymentRequest';
import { Creativeservicev1AdType } from '../models/Creativeservicev1AdType';
import { Creativeservicev1Audit } from '../models/Creativeservicev1Audit';
import { Creativeservicev1AuditResult } from '../models/Creativeservicev1AuditResult';
import { Creativeservicev1AuditStatus } from '../models/Creativeservicev1AuditStatus';
import { Creativeservicev1Checks } from '../models/Creativeservicev1Checks';
import { Creativeservicev1Creative } from '../models/Creativeservicev1Creative';
import { Creativeservicev1Dependency } from '../models/Creativeservicev1Dependency';
import { Creativeservicev1DeploymentType } from '../models/Creativeservicev1DeploymentType';
import { Creativeservicev1Destination } from '../models/Creativeservicev1Destination';
import { Creativeservicev1FileType } from '../models/Creativeservicev1FileType';
import { Creativeservicev1FolderStats } from '../models/Creativeservicev1FolderStats';
import { Creativeservicev1HealthCheck } from '../models/Creativeservicev1HealthCheck';
import { Creativeservicev1HealthCondition } from '../models/Creativeservicev1HealthCondition';
import { Creativeservicev1ListCreativesResponse } from '../models/Creativeservicev1ListCreativesResponse';
import { Creativeservicev1Miscellanea } from '../models/Creativeservicev1Miscellanea';
import { Creativeservicev1NativeMetadata } from '../models/Creativeservicev1NativeMetadata';
import { Creativeservicev1OrderLine } from '../models/Creativeservicev1OrderLine';
import { Creativeservicev1Status } from '../models/Creativeservicev1Status';
import { Creativeservicev1SystemStat } from '../models/Creativeservicev1SystemStat';
import { Creativeservicev1Type } from '../models/Creativeservicev1Type';
import { CreditCard } from '../models/CreditCard';
import { CreditCard1 } from '../models/CreditCard1';
import { DeployMetadataDeployedCPM } from '../models/DeployMetadataDeployedCPM';
import { DeployOrderLineRequest } from '../models/DeployOrderLineRequest';
import { Deployservicev3Audit } from '../models/Deployservicev3Audit';
import { Deployservicev3AuditResult } from '../models/Deployservicev3AuditResult';
import { Deployservicev3AuditStatus } from '../models/Deployservicev3AuditStatus';
import { Deployservicev3Campaign } from '../models/Deployservicev3Campaign';
import { Deployservicev3Checks } from '../models/Deployservicev3Checks';
import { Deployservicev3Creative } from '../models/Deployservicev3Creative';
import { Deployservicev3CreativeID } from '../models/Deployservicev3CreativeID';
import { Deployservicev3Dependency } from '../models/Deployservicev3Dependency';
import { Deployservicev3Deployment } from '../models/Deployservicev3Deployment';
import { Deployservicev3DeploymentType } from '../models/Deployservicev3DeploymentType';
import { Deployservicev3Destination } from '../models/Deployservicev3Destination';
import { Deployservicev3HealthCheck } from '../models/Deployservicev3HealthCheck';
import { Deployservicev3HealthCondition } from '../models/Deployservicev3HealthCondition';
import { Deployservicev3ListCampaignsResponse } from '../models/Deployservicev3ListCampaignsResponse';
import { Deployservicev3ListCreativesResponse } from '../models/Deployservicev3ListCreativesResponse';
import { Deployservicev3Miscellanea } from '../models/Deployservicev3Miscellanea';
import { Deployservicev3NativeMetadata } from '../models/Deployservicev3NativeMetadata';
import { Deployservicev3Status } from '../models/Deployservicev3Status';
import { Deployservicev3SystemStat } from '../models/Deployservicev3SystemStat';
import { Deployservicev3Value } from '../models/Deployservicev3Value';
import { DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries } from '../models/DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries';
import { ExistingUserWithNewFieldValues } from '../models/ExistingUserWithNewFieldValues';
import { GetDefaultTemplateRequest } from '../models/GetDefaultTemplateRequest';
import { GlobalSearchResponseCount } from '../models/GlobalSearchResponseCount';
import { GoogleprotobufAny } from '../models/GoogleprotobufAny';
import { GooglerpcStatus } from '../models/GooglerpcStatus';
import { Hagridv1Checks } from '../models/Hagridv1Checks';
import { Hagridv1Dependency } from '../models/Hagridv1Dependency';
import { Hagridv1FileMetaData } from '../models/Hagridv1FileMetaData';
import { Hagridv1HealthCheck } from '../models/Hagridv1HealthCheck';
import { Hagridv1HealthCondition } from '../models/Hagridv1HealthCondition';
import { Hagridv1ListUsersResponse } from '../models/Hagridv1ListUsersResponse';
import { Hagridv1Miscellanea } from '../models/Hagridv1Miscellanea';
import { Hagridv1SystemStat } from '../models/Hagridv1SystemStat';
import { Hagridv1User } from '../models/Hagridv1User';
import { Job } from '../models/Job';
import { LockOrderLineRequest } from '../models/LockOrderLineRequest';
import { MoveOrgsRequest } from '../models/MoveOrgsRequest';
import { Notification } from '../models/Notification';
import { Notificationservicev1Checks } from '../models/Notificationservicev1Checks';
import { Notificationservicev1Dependency } from '../models/Notificationservicev1Dependency';
import { Notificationservicev1HealthCheck } from '../models/Notificationservicev1HealthCheck';
import { Notificationservicev1HealthCondition } from '../models/Notificationservicev1HealthCondition';
import { Notificationservicev1Miscellanea } from '../models/Notificationservicev1Miscellanea';
import { Notificationservicev1SystemStat } from '../models/Notificationservicev1SystemStat';
import { Notificationservicev1Type } from '../models/Notificationservicev1Type';
import { OrderLineJobErrorDetail } from '../models/OrderLineJobErrorDetail';
import { OrderLineViantAdelphicIDsSetAudienceID } from '../models/OrderLineViantAdelphicIDsSetAudienceID';
import { Orgmanagerv1Checks } from '../models/Orgmanagerv1Checks';
import { Orgmanagerv1CommissionGroup } from '../models/Orgmanagerv1CommissionGroup';
import { Orgmanagerv1Contact } from '../models/Orgmanagerv1Contact';
import { Orgmanagerv1Dependency } from '../models/Orgmanagerv1Dependency';
import { Orgmanagerv1HealthCheck } from '../models/Orgmanagerv1HealthCheck';
import { Orgmanagerv1HealthCondition } from '../models/Orgmanagerv1HealthCondition';
import { Orgmanagerv1Miscellanea } from '../models/Orgmanagerv1Miscellanea';
import { Orgmanagerv1Note } from '../models/Orgmanagerv1Note';
import { Orgmanagerv1NoteType } from '../models/Orgmanagerv1NoteType';
import { Orgmanagerv1Org } from '../models/Orgmanagerv1Org';
import { Orgmanagerv1Status } from '../models/Orgmanagerv1Status';
import { Orgmanagerv1SystemStat } from '../models/Orgmanagerv1SystemStat';
import { Orgmanagerv1Timeframe } from '../models/Orgmanagerv1Timeframe';
import { Orgmanagerv1User } from '../models/Orgmanagerv1User';
import { Orgmanagerv2ListUsersResponse } from '../models/Orgmanagerv2ListUsersResponse';
import { Orgmanagerv2User } from '../models/Orgmanagerv2User';
import { PauseOrderLineRequest } from '../models/PauseOrderLineRequest';
import { PayInvoiceRequest } from '../models/PayInvoiceRequest';
import { PaySetUpFeeRequest } from '../models/PaySetUpFeeRequest';
import { PixelNote } from '../models/PixelNote';
import { PlayOrderLineRequest } from '../models/PlayOrderLineRequest';
import { PrepayRequest } from '../models/PrepayRequest';
import { ProtobufNullValue } from '../models/ProtobufNullValue';
import { RejectOrderLineRequest } from '../models/RejectOrderLineRequest';
import { RemoveAudienceRequest } from '../models/RemoveAudienceRequest';
import { RemoveCreativeRequest } from '../models/RemoveCreativeRequest';
import { RequestReviewRequest } from '../models/RequestReviewRequest';
import { SetDistributionRequest } from '../models/SetDistributionRequest';
import { StartReviewRequest } from '../models/StartReviewRequest';
import { StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries } from '../models/StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries';
import { StreamResultOfV1DownloadAudienceFileResponse } from '../models/StreamResultOfV1DownloadAudienceFileResponse';
import { StreamResultOfV1DownloadBundleResponse } from '../models/StreamResultOfV1DownloadBundleResponse';
import { StreamResultOfV1DownloadCreativeFileResponse } from '../models/StreamResultOfV1DownloadCreativeFileResponse';
import { StreamResultOfV1DownloadExclusionAddressesResponse } from '../models/StreamResultOfV1DownloadExclusionAddressesResponse';
import { StreamResultOfV1DownloadJobFileResponse } from '../models/StreamResultOfV1DownloadJobFileResponse';
import { StreamResultOfV1DownloadTOSAgreementResponse } from '../models/StreamResultOfV1DownloadTOSAgreementResponse';
import { StreamResultOfV2DownloadTargetFileResponse } from '../models/StreamResultOfV2DownloadTargetFileResponse';
import { SubscriptionNote } from '../models/SubscriptionNote';
import { Targetjobservicev1Audience } from '../models/Targetjobservicev1Audience';
import { Targetjobservicev1Checks } from '../models/Targetjobservicev1Checks';
import { Targetjobservicev1Column } from '../models/Targetjobservicev1Column';
import { Targetjobservicev1Dependency } from '../models/Targetjobservicev1Dependency';
import { Targetjobservicev1Deployment } from '../models/Targetjobservicev1Deployment';
import { Targetjobservicev1FolderStats } from '../models/Targetjobservicev1FolderStats';
import { Targetjobservicev1HealthCheck } from '../models/Targetjobservicev1HealthCheck';
import { Targetjobservicev1HealthCondition } from '../models/Targetjobservicev1HealthCondition';
import { Targetjobservicev1JobStatus } from '../models/Targetjobservicev1JobStatus';
import { Targetjobservicev1Miscellanea } from '../models/Targetjobservicev1Miscellanea';
import { Targetjobservicev1Note } from '../models/Targetjobservicev1Note';
import { Targetjobservicev1NoteType } from '../models/Targetjobservicev1NoteType';
import { Targetjobservicev1SystemStat } from '../models/Targetjobservicev1SystemStat';
import { Targetjobservicev1Timeframe } from '../models/Targetjobservicev1Timeframe';
import { Targetorchestratorv2Checks } from '../models/Targetorchestratorv2Checks';
import { Targetorchestratorv2Column } from '../models/Targetorchestratorv2Column';
import { Targetorchestratorv2Dependency } from '../models/Targetorchestratorv2Dependency';
import { Targetorchestratorv2FileMetaData } from '../models/Targetorchestratorv2FileMetaData';
import { Targetorchestratorv2FileType } from '../models/Targetorchestratorv2FileType';
import { Targetorchestratorv2FolderStats } from '../models/Targetorchestratorv2FolderStats';
import { Targetorchestratorv2HealthCheck } from '../models/Targetorchestratorv2HealthCheck';
import { Targetorchestratorv2HealthCondition } from '../models/Targetorchestratorv2HealthCondition';
import { Targetorchestratorv2Location } from '../models/Targetorchestratorv2Location';
import { Targetorchestratorv2Miscellanea } from '../models/Targetorchestratorv2Miscellanea';
import { Targetorchestratorv2SystemStat } from '../models/Targetorchestratorv2SystemStat';
import { TheAdvertiserToCreate } from '../models/TheAdvertiserToCreate';
import { TheAudienceToUpdate } from '../models/TheAudienceToUpdate';
import { TheAutomationToUpdate } from '../models/TheAutomationToUpdate';
import { TheCampaignToCreate } from '../models/TheCampaignToCreate';
import { TheCampaignToUpdate } from '../models/TheCampaignToUpdate';
import { TheCreativeToCreate } from '../models/TheCreativeToCreate';
import { TheCreativeToUpdate } from '../models/TheCreativeToUpdate';
import { TheDeploymentToCreate } from '../models/TheDeploymentToCreate';
import { TheNoteToUpdate } from '../models/TheNoteToUpdate';
import { TheOrderLineToUpdate } from '../models/TheOrderLineToUpdate';
import { TheOrganizationToUpdate } from '../models/TheOrganizationToUpdate';
import { TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask } from '../models/TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask';
import { TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask } from '../models/TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask';
import { TheSegmentToCreate } from '../models/TheSegmentToCreate';
import { TheTargetToUpdate } from '../models/TheTargetToUpdate';
import { TypeDate } from '../models/TypeDate';
import { TypeMoney } from '../models/TypeMoney';
import { UnlockOrderLineRequest } from '../models/UnlockOrderLineRequest';
import { UpdateCPMsRequest } from '../models/UpdateCPMsRequest';
import { UpdateDeploymentRequest } from '../models/UpdateDeploymentRequest';
import { V1AccountingJob } from '../models/V1AccountingJob';
import { V1AccountingJobKind } from '../models/V1AccountingJobKind';
import { V1AdditionalArguments } from '../models/V1AdditionalArguments';
import { V1AdminInvoice } from '../models/V1AdminInvoice';
import { V1AdminListNotificationsResponse } from '../models/V1AdminListNotificationsResponse';
import { V1ArchiveCampaignRequest } from '../models/V1ArchiveCampaignRequest';
import { V1ArchiveCreativeRequest } from '../models/V1ArchiveCreativeRequest';
import { V1ArchiveOrderLineRequest } from '../models/V1ArchiveOrderLineRequest';
import { V1Asset } from '../models/V1Asset';
import { V1AssetType } from '../models/V1AssetType';
import { V1Assignment } from '../models/V1Assignment';
import { V1AttachExcludedAddressesRequest } from '../models/V1AttachExcludedAddressesRequest';
import { V1Attachment } from '../models/V1Attachment';
import { V1AudienceAdded } from '../models/V1AudienceAdded';
import { V1AudienceFileType } from '../models/V1AudienceFileType';
import { V1AudienceRemoved } from '../models/V1AudienceRemoved';
import { V1AudienceStatus } from '../models/V1AudienceStatus';
import { V1AudienceSubType } from '../models/V1AudienceSubType';
import { V1AudienceType } from '../models/V1AudienceType';
import { V1AuditConditions } from '../models/V1AuditConditions';
import { V1Authorization } from '../models/V1Authorization';
import { V1Automation } from '../models/V1Automation';
import { V1AutomationType } from '../models/V1AutomationType';
import { V1AuxiliaryFileFilter } from '../models/V1AuxiliaryFileFilter';
import { V1Balance } from '../models/V1Balance';
import { V1BatchAddAudiencesRequestAudience } from '../models/V1BatchAddAudiencesRequestAudience';
import { V1BatchUpdateOrderLinesRequest } from '../models/V1BatchUpdateOrderLinesRequest';
import { V1BatchUpdateOrderLinesResponse } from '../models/V1BatchUpdateOrderLinesResponse';
import { V1BatchUpdateOrgsRequest } from '../models/V1BatchUpdateOrgsRequest';
import { V1BatchUpdateOrgsResponse } from '../models/V1BatchUpdateOrgsResponse';
import { V1BrandingMode } from '../models/V1BrandingMode';
import { V1BundleRequest } from '../models/V1BundleRequest';
import { V1CPM } from '../models/V1CPM';
import { V1CPMOverride } from '../models/V1CPMOverride';
import { V1CampaignArchived } from '../models/V1CampaignArchived';
import { V1CampaignCreated } from '../models/V1CampaignCreated';
import { V1CampaignDeleted } from '../models/V1CampaignDeleted';
import { V1CampaignEvent } from '../models/V1CampaignEvent';
import { V1CampaignFlightDatesSet } from '../models/V1CampaignFlightDatesSet';
import { V1CampaignJobIdSet } from '../models/V1CampaignJobIdSet';
import { V1CampaignNameSet } from '../models/V1CampaignNameSet';
import { V1CampaignOrderLine } from '../models/V1CampaignOrderLine';
import { V1CampaignPoIdSet } from '../models/V1CampaignPoIdSet';
import { V1CampaignPoliticalIndependentExpenditureFormPathSet } from '../models/V1CampaignPoliticalIndependentExpenditureFormPathSet';
import { V1CampaignPoliticalIndependentExpenditureStateSet } from '../models/V1CampaignPoliticalIndependentExpenditureStateSet';
import { V1CampaignPoliticalTransparencySet } from '../models/V1CampaignPoliticalTransparencySet';
import { V1CampaignRefIDSet } from '../models/V1CampaignRefIDSet';
import { V1CampaignSearch } from '../models/V1CampaignSearch';
import { V1CampaignUnarchived } from '../models/V1CampaignUnarchived';
import { V1CancelAudienceGenerationRequest } from '../models/V1CancelAudienceGenerationRequest';
import { V1ClientRoles } from '../models/V1ClientRoles';
import { V1CloneAudienceRequest } from '../models/V1CloneAudienceRequest';
import { V1CombinationRule } from '../models/V1CombinationRule';
import { V1CommissionType } from '../models/V1CommissionType';
import { V1ComponentResult } from '../models/V1ComponentResult';
import { V1ComponentResults } from '../models/V1ComponentResults';
import { V1CostRange } from '../models/V1CostRange';
import { V1CpmPlus } from '../models/V1CpmPlus';
import { V1CreateEmailMappingRequest } from '../models/V1CreateEmailMappingRequest';
import { V1CreateReportResponse } from '../models/V1CreateReportResponse';
import { V1CreateRouteRequest } from '../models/V1CreateRouteRequest';
import { V1CreativeAdded } from '../models/V1CreativeAdded';
import { V1CreativeFile } from '../models/V1CreativeFile';
import { V1CreativeFileMetadata } from '../models/V1CreativeFileMetadata';
import { V1CreativeRemoved } from '../models/V1CreativeRemoved';
import { V1CreativeSearch } from '../models/V1CreativeSearch';
import { V1CredentialRepresentation } from '../models/V1CredentialRepresentation';
import { V1CreditCard } from '../models/V1CreditCard';
import { V1CronResponse } from '../models/V1CronResponse';
import { V1CsvExportConfig } from '../models/V1CsvExportConfig';
import { V1DataProduct } from '../models/V1DataProduct';
import { V1DataSource } from '../models/V1DataSource';
import { V1DataSourcesHighestUpcharge } from '../models/V1DataSourcesHighestUpcharge';
import { V1DayOfWeek } from '../models/V1DayOfWeek';
import { V1DeployMetadata } from '../models/V1DeployMetadata';
import { V1DestinationAllocation } from '../models/V1DestinationAllocation';
import { V1DetachExcludedAddressesRequest } from '../models/V1DetachExcludedAddressesRequest';
import { V1DeviceMainDetails } from '../models/V1DeviceMainDetails';
import { V1DeviceResultIDs } from '../models/V1DeviceResultIDs';
import { V1DeviceResults } from '../models/V1DeviceResults';
import { V1DeviceStatsResponse } from '../models/V1DeviceStatsResponse';
import { V1DeviceSubDetails } from '../models/V1DeviceSubDetails';
import { V1Distribution } from '../models/V1Distribution';
import { V1DownloadAudienceFileResponse } from '../models/V1DownloadAudienceFileResponse';
import { V1DownloadBundleResponse } from '../models/V1DownloadBundleResponse';
import { V1DownloadCreativeFileResponse } from '../models/V1DownloadCreativeFileResponse';
import { V1DownloadExclusionAddressesResponse } from '../models/V1DownloadExclusionAddressesResponse';
import { V1DownloadJobFileResponse } from '../models/V1DownloadJobFileResponse';
import { V1DownloadTOSAgreementResponse } from '../models/V1DownloadTOSAgreementResponse';
import { V1EmailDestinations } from '../models/V1EmailDestinations';
import { V1EmailMapping } from '../models/V1EmailMapping';
import { V1EmailTemplateConfig } from '../models/V1EmailTemplateConfig';
import { V1Entry } from '../models/V1Entry';
import { V1Excludes } from '../models/V1Excludes';
import { V1ExclusionAddresses } from '../models/V1ExclusionAddresses';
import { V1ExclusionAddressesAttached } from '../models/V1ExclusionAddressesAttached';
import { V1ExclusionAddressesDetached } from '../models/V1ExclusionAddressesDetached';
import { V1ExclusionAddressesFileMetaData } from '../models/V1ExclusionAddressesFileMetaData';
import { V1ExportConfig } from '../models/V1ExportConfig';
import { V1ExportDataResponse } from '../models/V1ExportDataResponse';
import { V1ExportType } from '../models/V1ExportType';
import { V1FTP } from '../models/V1FTP';
import { V1FileFilters } from '../models/V1FileFilters';
import { V1FileSubType } from '../models/V1FileSubType';
import { V1FrequencyConfig } from '../models/V1FrequencyConfig';
import { V1GetNewMoverMatchCountResponse } from '../models/V1GetNewMoverMatchCountResponse';
import { V1GetNotificationsResponse } from '../models/V1GetNotificationsResponse';
import { V1GetTemplateResponse } from '../models/V1GetTemplateResponse';
import { V1GetUserIPResponse } from '../models/V1GetUserIPResponse';
import { V1GlobalSearchResponse } from '../models/V1GlobalSearchResponse';
import { V1HighestCPMAudience } from '../models/V1HighestCPMAudience';
import { V1Includes } from '../models/V1Includes';
import { V1IntervalUnit } from '../models/V1IntervalUnit';
import { V1JWT } from '../models/V1JWT';
import { V1Job } from '../models/V1Job';
import { V1JobFileType } from '../models/V1JobFileType';
import { V1JobSearch } from '../models/V1JobSearch';
import { V1JobSubType } from '../models/V1JobSubType';
import { V1JobTemplate } from '../models/V1JobTemplate';
import { V1JobType } from '../models/V1JobType';
import { V1ListAccountingJobsResponse } from '../models/V1ListAccountingJobsResponse';
import { V1ListAssetsResponse } from '../models/V1ListAssetsResponse';
import { V1ListAudienceFoldersResponse } from '../models/V1ListAudienceFoldersResponse';
import { V1ListAudiencesResponse } from '../models/V1ListAudiencesResponse';
import { V1ListCampaignEventsResponse } from '../models/V1ListCampaignEventsResponse';
import { V1ListCommissionGroupsResponse } from '../models/V1ListCommissionGroupsResponse';
import { V1ListCreativeFoldersResponse } from '../models/V1ListCreativeFoldersResponse';
import { V1ListCreditCardsResponse } from '../models/V1ListCreditCardsResponse';
import { V1ListEmailMappingsResponse } from '../models/V1ListEmailMappingsResponse';
import { V1ListExclusionAddressesResponse } from '../models/V1ListExclusionAddressesResponse';
import { V1ListOfString } from '../models/V1ListOfString';
import { V1ListOrderLineEventsResponse } from '../models/V1ListOrderLineEventsResponse';
import { V1ListOrderLineJobsResponse } from '../models/V1ListOrderLineJobsResponse';
import { V1ListOrderLinesResponse } from '../models/V1ListOrderLinesResponse';
import { V1ListOrgSubscriptionsResponse } from '../models/V1ListOrgSubscriptionsResponse';
import { V1ListOrgUsersResponse } from '../models/V1ListOrgUsersResponse';
import { V1ListOrgsResponse } from '../models/V1ListOrgsResponse';
import { V1ListPixelsResponse } from '../models/V1ListPixelsResponse';
import { V1ListPublisherSubscriptionsResponse } from '../models/V1ListPublisherSubscriptionsResponse';
import { V1ListPublishersResponse } from '../models/V1ListPublishersResponse';
import { V1ListReportRunsResponse } from '../models/V1ListReportRunsResponse';
import { V1ListReportsResponse } from '../models/V1ListReportsResponse';
import { V1ListRoutesResponse } from '../models/V1ListRoutesResponse';
import { V1ListRulesResponse } from '../models/V1ListRulesResponse';
import { V1ListSchedulesResponse } from '../models/V1ListSchedulesResponse';
import { V1ListStatsResponse } from '../models/V1ListStatsResponse';
import { V1ListSubscriptionsResponse } from '../models/V1ListSubscriptionsResponse';
import { V1ListTOSAgreementsResponse } from '../models/V1ListTOSAgreementsResponse';
import { V1ListTotalStatsResponse } from '../models/V1ListTotalStatsResponse';
import { V1MainDetails } from '../models/V1MainDetails';
import { V1MatchMode } from '../models/V1MatchMode';
import { V1MatchScope } from '../models/V1MatchScope';
import { V1Medium } from '../models/V1Medium';
import { V1Message } from '../models/V1Message';
import { V1MessageType } from '../models/V1MessageType';
import { V1Metrics } from '../models/V1Metrics';
import { V1MetricsGranularity } from '../models/V1MetricsGranularity';
import { V1MonthlyFrequencyConfig } from '../models/V1MonthlyFrequencyConfig';
import { V1MoverMatchCount } from '../models/V1MoverMatchCount';
import { V1Notification } from '../models/V1Notification';
import { V1OAuthTokenRequest } from '../models/V1OAuthTokenRequest';
import { V1OrderLineAdTypeSet } from '../models/V1OrderLineAdTypeSet';
import { V1OrderLineApproved } from '../models/V1OrderLineApproved';
import { V1OrderLineArchived } from '../models/V1OrderLineArchived';
import { V1OrderLineAuditConditionsSet } from '../models/V1OrderLineAuditConditionsSet';
import { V1OrderLineCPMOverrideRemoved } from '../models/V1OrderLineCPMOverrideRemoved';
import { V1OrderLineCPMOverriden } from '../models/V1OrderLineCPMOverriden';
import { V1OrderLineCPMSet } from '../models/V1OrderLineCPMSet';
import { V1OrderLineCampaign } from '../models/V1OrderLineCampaign';
import { V1OrderLineClickThroughURLSet } from '../models/V1OrderLineClickThroughURLSet';
import { V1OrderLineCloneRequestFailed } from '../models/V1OrderLineCloneRequestFailed';
import { V1OrderLineCloneRequestSucceeded } from '../models/V1OrderLineCloneRequestSucceeded';
import { V1OrderLineCloned } from '../models/V1OrderLineCloned';
import { V1OrderLineCompleted } from '../models/V1OrderLineCompleted';
import { V1OrderLineCostSet } from '../models/V1OrderLineCostSet';
import { V1OrderLineCreated } from '../models/V1OrderLineCreated';
import { V1OrderLineDeleted } from '../models/V1OrderLineDeleted';
import { V1OrderLineDeployed } from '../models/V1OrderLineDeployed';
import { V1OrderLineDeployedToDestinationRTB } from '../models/V1OrderLineDeployedToDestinationRTB';
import { V1OrderLineDeployedToDestinationStackAdapt } from '../models/V1OrderLineDeployedToDestinationStackAdapt';
import { V1OrderLineDeployedToDestinationXandrCurate } from '../models/V1OrderLineDeployedToDestinationXandrCurate';
import { V1OrderLineDeployedToDestinationXandrInvest } from '../models/V1OrderLineDeployedToDestinationXandrInvest';
import { V1OrderLineDeployedWithConfig } from '../models/V1OrderLineDeployedWithConfig';
import { V1OrderLineDeploymentCancelled } from '../models/V1OrderLineDeploymentCancelled';
import { V1OrderLineDeploymentCancelling } from '../models/V1OrderLineDeploymentCancelling';
import { V1OrderLineDeploymentDestinationSet } from '../models/V1OrderLineDeploymentDestinationSet';
import { V1OrderLineDestinationRTBCreated } from '../models/V1OrderLineDestinationRTBCreated';
import { V1OrderLineDestinationRTBSet } from '../models/V1OrderLineDestinationRTBSet';
import { V1OrderLineDestinationStackAdaptCreated } from '../models/V1OrderLineDestinationStackAdaptCreated';
import { V1OrderLineDestinationStackAdaptSet } from '../models/V1OrderLineDestinationStackAdaptSet';
import { V1OrderLineDestinationXandrCurateCreated } from '../models/V1OrderLineDestinationXandrCurateCreated';
import { V1OrderLineDestinationXandrCurateSet } from '../models/V1OrderLineDestinationXandrCurateSet';
import { V1OrderLineDestinationXandrInvestCreated } from '../models/V1OrderLineDestinationXandrInvestCreated';
import { V1OrderLineDestinationXandrInvestSet } from '../models/V1OrderLineDestinationXandrInvestSet';
import { V1OrderLineDistributionSet } from '../models/V1OrderLineDistributionSet';
import { V1OrderLineEndTimeSet } from '../models/V1OrderLineEndTimeSet';
import { V1OrderLineErroredDeployingToDestinationRTB } from '../models/V1OrderLineErroredDeployingToDestinationRTB';
import { V1OrderLineErroredDeployingToDestinationStackAdapt } from '../models/V1OrderLineErroredDeployingToDestinationStackAdapt';
import { V1OrderLineErroredDeployingToDestinationXandrCurate } from '../models/V1OrderLineErroredDeployingToDestinationXandrCurate';
import { V1OrderLineErroredDeployingToDestinationXandrInvest } from '../models/V1OrderLineErroredDeployingToDestinationXandrInvest';
import { V1OrderLineEvent } from '../models/V1OrderLineEvent';
import { V1OrderLineFreeImpressionsSet } from '../models/V1OrderLineFreeImpressionsSet';
import { V1OrderLineImpressionsPerDaySet } from '../models/V1OrderLineImpressionsPerDaySet';
import { V1OrderLineImpressionsSet } from '../models/V1OrderLineImpressionsSet';
import { V1OrderLineJob } from '../models/V1OrderLineJob';
import { V1OrderLineJobIdSet } from '../models/V1OrderLineJobIdSet';
import { V1OrderLineLocked } from '../models/V1OrderLineLocked';
import { V1OrderLineMigrated } from '../models/V1OrderLineMigrated';
import { V1OrderLineMinimumImpressionsSet } from '../models/V1OrderLineMinimumImpressionsSet';
import { V1OrderLineNameSet } from '../models/V1OrderLineNameSet';
import { V1OrderLineNoteAppended } from '../models/V1OrderLineNoteAppended';
import { V1OrderLineNoteDeactivated } from '../models/V1OrderLineNoteDeactivated';
import { V1OrderLineNoteUpdated } from '../models/V1OrderLineNoteUpdated';
import { V1OrderLinePaidSet } from '../models/V1OrderLinePaidSet';
import { V1OrderLinePaused } from '../models/V1OrderLinePaused';
import { V1OrderLinePlayed } from '../models/V1OrderLinePlayed';
import { V1OrderLinePoIdSet } from '../models/V1OrderLinePoIdSet';
import { V1OrderLinePoliticalFieldsSet } from '../models/V1OrderLinePoliticalFieldsSet';
import { V1OrderLinePrepaySet } from '../models/V1OrderLinePrepaySet';
import { V1OrderLineRedeployVerificationFailed } from '../models/V1OrderLineRedeployVerificationFailed';
import { V1OrderLineRefIdSet } from '../models/V1OrderLineRefIdSet';
import { V1OrderLineRejected } from '../models/V1OrderLineRejected';
import { V1OrderLineReviewStarted } from '../models/V1OrderLineReviewStarted';
import { V1OrderLineSearch } from '../models/V1OrderLineSearch';
import { V1OrderLineSegmentConfigSet } from '../models/V1OrderLineSegmentConfigSet';
import { V1OrderLineStartTimeSet } from '../models/V1OrderLineStartTimeSet';
import { V1OrderLineStateSetToActive } from '../models/V1OrderLineStateSetToActive';
import { V1OrderLineStateSetToPaused } from '../models/V1OrderLineStateSetToPaused';
import { V1OrderLineStatus } from '../models/V1OrderLineStatus';
import { V1OrderLineStatusSetToDeploying } from '../models/V1OrderLineStatusSetToDeploying';
import { V1OrderLineStatusSetToDraft } from '../models/V1OrderLineStatusSetToDraft';
import { V1OrderLineStatusSetToPrevious } from '../models/V1OrderLineStatusSetToPrevious';
import { V1OrderLineStepFunctionSet } from '../models/V1OrderLineStepFunctionSet';
import { V1OrderLineTemplateTypeSet } from '../models/V1OrderLineTemplateTypeSet';
import { V1OrderLineUnarchived } from '../models/V1OrderLineUnarchived';
import { V1OrderLineUnlocked } from '../models/V1OrderLineUnlocked';
import { V1OrderLineViantAdelphicConfigurationSet } from '../models/V1OrderLineViantAdelphicConfigurationSet';
import { V1OrderLineViantAdelphicIDsSet } from '../models/V1OrderLineViantAdelphicIDsSet';
import { V1OrderLineViantAdelphicIDsSetCreativeID } from '../models/V1OrderLineViantAdelphicIDsSetCreativeID';
import { V1OrgData } from '../models/V1OrgData';
import { V1OrgLogo } from '../models/V1OrgLogo';
import { V1PayOrderLinesRequest } from '../models/V1PayOrderLinesRequest';
import { V1PdfExportConfig } from '../models/V1PdfExportConfig';
import { V1Pixel } from '../models/V1Pixel';
import { V1PixelCreated } from '../models/V1PixelCreated';
import { V1PixelNote } from '../models/V1PixelNote';
import { V1PixelUpdated } from '../models/V1PixelUpdated';
import { V1PoliticalFields } from '../models/V1PoliticalFields';
import { V1PoliticalTransparency } from '../models/V1PoliticalTransparency';
import { V1ProductType } from '../models/V1ProductType';
import { V1Publisher } from '../models/V1Publisher';
import { V1PublisherSubscription } from '../models/V1PublisherSubscription';
import { V1QueueDetails } from '../models/V1QueueDetails';
import { V1QueueHealth } from '../models/V1QueueHealth';
import { V1RebuildGlobalSearchRequest } from '../models/V1RebuildGlobalSearchRequest';
import { V1RebuildGlobalSearchResourceType } from '../models/V1RebuildGlobalSearchResourceType';
import { V1Report } from '../models/V1Report';
import { V1ReportGranularity } from '../models/V1ReportGranularity';
import { V1ReportRun } from '../models/V1ReportRun';
import { V1ReportRunStatus } from '../models/V1ReportRunStatus';
import { V1ReportType } from '../models/V1ReportType';
import { V1RequestOrgNameChangeRequest } from '../models/V1RequestOrgNameChangeRequest';
import { V1RequestSupportRequest } from '../models/V1RequestSupportRequest';
import { V1Result } from '../models/V1Result';
import { V1ResultIDs } from '../models/V1ResultIDs';
import { V1ResultMetrics } from '../models/V1ResultMetrics';
import { V1Results } from '../models/V1Results';
import { V1ReviewRequested } from '../models/V1ReviewRequested';
import { V1Route } from '../models/V1Route';
import { V1RouteJobReport } from '../models/V1RouteJobReport';
import { V1Rule } from '../models/V1Rule';
import { V1RuleSet } from '../models/V1RuleSet';
import { V1RunCommissionsRequest } from '../models/V1RunCommissionsRequest';
import { V1RunCommissionsResponse } from '../models/V1RunCommissionsResponse';
import { V1RunInvoicingRequest } from '../models/V1RunInvoicingRequest';
import { V1RunInvoicingResponse } from '../models/V1RunInvoicingResponse';
import { V1Schedule } from '../models/V1Schedule';
import { V1ScheduleFrequency } from '../models/V1ScheduleFrequency';
import { V1ScheduleStatus } from '../models/V1ScheduleStatus';
import { V1SendMessageRequest } from '../models/V1SendMessageRequest';
import { V1SetCampaignPoliticalFormRequest } from '../models/V1SetCampaignPoliticalFormRequest';
import { V1SlackTemplateConfig } from '../models/V1SlackTemplateConfig';
import { V1State } from '../models/V1State';
import { V1Stats } from '../models/V1Stats';
import { V1StatsResponse } from '../models/V1StatsResponse';
import { V1StringList } from '../models/V1StringList';
import { V1SubDetails } from '../models/V1SubDetails';
import { V1Subscription } from '../models/V1Subscription';
import { V1SubscriptionCreated } from '../models/V1SubscriptionCreated';
import { V1SubscriptionNote } from '../models/V1SubscriptionNote';
import { V1SubscriptionUpdated } from '../models/V1SubscriptionUpdated';
import { V1TOSAgreement } from '../models/V1TOSAgreement';
import { V1TargetJobSearch } from '../models/V1TargetJobSearch';
import { V1TargetSearch } from '../models/V1TargetSearch';
import { V1TemplateConfigType } from '../models/V1TemplateConfigType';
import { V1TemplateReport } from '../models/V1TemplateReport';
import { V1TemplateType } from '../models/V1TemplateType';
import { V1TemplateVariableValue } from '../models/V1TemplateVariableValue';
import { V1TimeframePreset } from '../models/V1TimeframePreset';
import { V1TriggerRouteResponse } from '../models/V1TriggerRouteResponse';
import { V1UnarchiveCreativeRequest } from '../models/V1UnarchiveCreativeRequest';
import { V1UnarchiveOrderLineRequest } from '../models/V1UnarchiveOrderLineRequest';
import { V1Upcharge } from '../models/V1Upcharge';
import { V1UpdateOrderLineRequest } from '../models/V1UpdateOrderLineRequest';
import { V1UpdateOrgRequest } from '../models/V1UpdateOrgRequest';
import { V1UploadAssetMetadata } from '../models/V1UploadAssetMetadata';
import { V1UploadAssetRequest } from '../models/V1UploadAssetRequest';
import { V1UploadCreativeFileRequest } from '../models/V1UploadCreativeFileRequest';
import { V1UploadExclusionAddressesRequest } from '../models/V1UploadExclusionAddressesRequest';
import { V1UploadOrderLineJobRequest } from '../models/V1UploadOrderLineJobRequest';
import { V1UploadOrgLogoMetadata } from '../models/V1UploadOrgLogoMetadata';
import { V1UploadTOSAgreementRequest } from '../models/V1UploadTOSAgreementRequest';
import { V1WebToHomeEvent } from '../models/V1WebToHomeEvent';
import { V1WebToHomeNoteType } from '../models/V1WebToHomeNoteType';
import { V1WeeklyFrequencyConfig } from '../models/V1WeeklyFrequencyConfig';
import { V2ArchiveTargetRequest } from '../models/V2ArchiveTargetRequest';
import { V2CreateJsonTargetRequest } from '../models/V2CreateJsonTargetRequest';
import { V2DownloadTargetFileResponse } from '../models/V2DownloadTargetFileResponse';
import { V2ListTargetFoldersResponse } from '../models/V2ListTargetFoldersResponse';
import { V2ListTargetsResponse } from '../models/V2ListTargetsResponse';
import { V2ReplaceFileMetaData } from '../models/V2ReplaceFileMetaData';
import { V2ReplaceTargetFileRequest } from '../models/V2ReplaceTargetFileRequest';
import { V2Target } from '../models/V2Target';
import { V2TargetJob } from '../models/V2TargetJob';
import { V2TargetStatus } from '../models/V2TargetStatus';
import { V2UnarchiveTargetRequest } from '../models/V2UnarchiveTargetRequest';
import { V2UploadTargetFileRequest } from '../models/V2UploadTargetFileRequest';
import { V3Advertiser } from '../models/V3Advertiser';
import { V3AuctionEvent } from '../models/V3AuctionEvent';
import { V3AugmentedLineItem } from '../models/V3AugmentedLineItem';
import { V3BrowserTarget } from '../models/V3BrowserTarget';
import { V3BudgetInterval } from '../models/V3BudgetInterval';
import { V3BudgetSchedulingSettings } from '../models/V3BudgetSchedulingSettings';
import { V3BuyerSeat } from '../models/V3BuyerSeat';
import { V3CampaignCreative } from '../models/V3CampaignCreative';
import { V3CampaignDeviceCaps } from '../models/V3CampaignDeviceCaps';
import { V3Condition } from '../models/V3Condition';
import { V3ConsoleCampaign } from '../models/V3ConsoleCampaign';
import { V3ContextualTargeting } from '../models/V3ContextualTargeting';
import { V3CountryTarget } from '../models/V3CountryTarget';
import { V3CreativeType } from '../models/V3CreativeType';
import { V3CurateCampaign } from '../models/V3CurateCampaign';
import { V3CustomDateRange } from '../models/V3CustomDateRange';
import { V3DaypartTarget } from '../models/V3DaypartTarget';
import { V3Deal } from '../models/V3Deal';
import { V3DealConfig } from '../models/V3DealConfig';
import { V3DealList } from '../models/V3DealList';
import { V3DealType } from '../models/V3DealType';
import { V3DeploySegmentsToCurateRequest } from '../models/V3DeploySegmentsToCurateRequest';
import { V3DeploymentDestinationConfigurations } from '../models/V3DeploymentDestinationConfigurations';
import { V3DirectMailCampaign } from '../models/V3DirectMailCampaign';
import { V3DirectMailConfiguration } from '../models/V3DirectMailConfiguration';
import { V3DomainListTarget } from '../models/V3DomainListTarget';
import { V3EngagementRateTarget } from '../models/V3EngagementRateTarget';
import { V3GenericDeployRequest } from '../models/V3GenericDeployRequest';
import { V3GovernmentLevel } from '../models/V3GovernmentLevel';
import { V3InventoryAttributeTarget } from '../models/V3InventoryAttributeTarget';
import { V3InventoryListTarget } from '../models/V3InventoryListTarget';
import { V3InvestCampaign } from '../models/V3InvestCampaign';
import { V3Language } from '../models/V3Language';
import { V3LanguageTarget } from '../models/V3LanguageTarget';
import { V3LegacyCampaign } from '../models/V3LegacyCampaign';
import { V3LineItem } from '../models/V3LineItem';
import { V3LineItemDeal } from '../models/V3LineItemDeal';
import { V3LineItemPixel } from '../models/V3LineItemPixel';
import { V3ListAdvertisersResponse } from '../models/V3ListAdvertisersResponse';
import { V3ListDeploymentsResponse } from '../models/V3ListDeploymentsResponse';
import { V3ListSegmentsResponse } from '../models/V3ListSegmentsResponse';
import { V3ListXandrDealListsResponse } from '../models/V3ListXandrDealListsResponse';
import { V3ListXandrDealsResponse } from '../models/V3ListXandrDealsResponse';
import { V3ListXandrLanguagesResponse } from '../models/V3ListXandrLanguagesResponse';
import { V3ListXandrRegionsResponse } from '../models/V3ListXandrRegionsResponse';
import { V3MemberDataSharing } from '../models/V3MemberDataSharing';
import { V3MemberDataSharingSegment } from '../models/V3MemberDataSharingSegment';
import { V3NonSeamlessInsertionOrder } from '../models/V3NonSeamlessInsertionOrder';
import { V3PacingStrategies } from '../models/V3PacingStrategies';
import { V3PoliticalContent } from '../models/V3PoliticalContent';
import { V3Position } from '../models/V3Position';
import { V3PositionTargets } from '../models/V3PositionTargets';
import { V3Profile } from '../models/V3Profile';
import { V3QueueRequest } from '../models/V3QueueRequest';
import { V3RTBCampaign } from '../models/V3RTBCampaign';
import { V3RTBConfiguration } from '../models/V3RTBConfiguration';
import { V3RTBCreativeMap } from '../models/V3RTBCreativeMap';
import { V3RTBCreativeMapping } from '../models/V3RTBCreativeMapping';
import { V3RTBOrderLine } from '../models/V3RTBOrderLine';
import { V3RTBOrderLineUpdateStatus } from '../models/V3RTBOrderLineUpdateStatus';
import { V3Region } from '../models/V3Region';
import { V3RegionTarget } from '../models/V3RegionTarget';
import { V3RegistrationForm } from '../models/V3RegistrationForm';
import { V3ResolveSegmentorIncidentResponse } from '../models/V3ResolveSegmentorIncidentResponse';
import { V3SGSegment } from '../models/V3SGSegment';
import { V3SeamlessInsertionOrder } from '../models/V3SeamlessInsertionOrder';
import { V3Segment } from '../models/V3Segment';
import { V3SegmentConfig } from '../models/V3SegmentConfig';
import { V3SegmentGroupTarget } from '../models/V3SegmentGroupTarget';
import { V3SegmentType } from '../models/V3SegmentType';
import { V3SegmentorDeploymentResults } from '../models/V3SegmentorDeploymentResults';
import { V3Split } from '../models/V3Split';
import { V3StackAdaptAd } from '../models/V3StackAdaptAd';
import { V3StackAdaptAudience } from '../models/V3StackAdaptAudience';
import { V3StackAdaptBidFactor } from '../models/V3StackAdaptBidFactor';
import { V3StackAdaptCampaign } from '../models/V3StackAdaptCampaign';
import { V3StackAdaptCampaignConfig } from '../models/V3StackAdaptCampaignConfig';
import { V3StackAdaptCampaignFlight } from '../models/V3StackAdaptCampaignFlight';
import { V3StackAdaptCampaignGoal } from '../models/V3StackAdaptCampaignGoal';
import { V3StackAdaptCampaignGroupConfig } from '../models/V3StackAdaptCampaignGroupConfig';
import { V3StackAdaptCampaignUpdateStatus } from '../models/V3StackAdaptCampaignUpdateStatus';
import { V3StackAdaptConfiguration } from '../models/V3StackAdaptConfiguration';
import { V3StackAdaptCreative } from '../models/V3StackAdaptCreative';
import { V3StackAdaptCreativeAdMapping } from '../models/V3StackAdaptCreativeAdMapping';
import { V3StackAdaptCreativeAdMappingStatus } from '../models/V3StackAdaptCreativeAdMappingStatus';
import { V3StackAdaptCreativeMap } from '../models/V3StackAdaptCreativeMap';
import { V3StackAdaptCreativeMapping } from '../models/V3StackAdaptCreativeMapping';
import { V3StackAdaptCreativeTactic } from '../models/V3StackAdaptCreativeTactic';
import { V3StackAdaptCreativeTag } from '../models/V3StackAdaptCreativeTag';
import { V3StackAdaptDayOption } from '../models/V3StackAdaptDayOption';
import { V3StackAdaptDayOptions } from '../models/V3StackAdaptDayOptions';
import { V3StackAdaptDayParting } from '../models/V3StackAdaptDayParting';
import { V3StackAdaptDeviceTypeRule } from '../models/V3StackAdaptDeviceTypeRule';
import { V3StackAdaptFlight } from '../models/V3StackAdaptFlight';
import { V3StackAdaptGeoTargeting } from '../models/V3StackAdaptGeoTargeting';
import { V3StackAdaptGlobalZipTargeting } from '../models/V3StackAdaptGlobalZipTargeting';
import { V3StackAdaptGoal } from '../models/V3StackAdaptGoal';
import { V3StackAdaptHourlyParting } from '../models/V3StackAdaptHourlyParting';
import { V3StackAdaptInventoryConfig } from '../models/V3StackAdaptInventoryConfig';
import { V3StackAdaptLibraryAd } from '../models/V3StackAdaptLibraryAd';
import { V3StackAdaptSegmentMap } from '../models/V3StackAdaptSegmentMap';
import { V3StackAdaptSegmentMapping } from '../models/V3StackAdaptSegmentMapping';
import { V3StackAdaptTacticAd } from '../models/V3StackAdaptTacticAd';
import { V3StackAdaptTacticCustomSegmentRule } from '../models/V3StackAdaptTacticCustomSegmentRule';
import { V3StackAdaptTacticDateRule } from '../models/V3StackAdaptTacticDateRule';
import { V3StackAdaptTacticDayTimeRule } from '../models/V3StackAdaptTacticDayTimeRule';
import { V3StackAdaptTacticLanguageRule } from '../models/V3StackAdaptTacticLanguageRule';
import { V3StackAdaptTacticWeekDayRule } from '../models/V3StackAdaptTacticWeekDayRule';
import { V3StackAdaptTimeSlot } from '../models/V3StackAdaptTimeSlot';
import { V3StackAdaptUserMetadata } from '../models/V3StackAdaptUserMetadata';
import { V3StackAdaptVastMedia } from '../models/V3StackAdaptVastMedia';
import { V3StackAdaptVastMediaData } from '../models/V3StackAdaptVastMediaData';
import { V3StackAdaptVastTracker } from '../models/V3StackAdaptVastTracker';
import { V3StackAdaptWeekdayParting } from '../models/V3StackAdaptWeekdayParting';
import { V3StartSegmentorIncidentRequest } from '../models/V3StartSegmentorIncidentRequest';
import { V3StartSegmentorIncidentResponse } from '../models/V3StartSegmentorIncidentResponse';
import { V3SupplyStrategies } from '../models/V3SupplyStrategies';
import { V3UserInfo } from '../models/V3UserInfo';
import { V3Valuation } from '../models/V3Valuation';
import { V3Values } from '../models/V3Values';
import { V3ViantAdelphicConfiguration } from '../models/V3ViantAdelphicConfiguration';
import { V3ViantCreativeConfig } from '../models/V3ViantCreativeConfig';
import { V3ViantSegmentConfig } from '../models/V3ViantSegmentConfig';
import { V3XandrConsoleConfiguration } from '../models/V3XandrConsoleConfiguration';
import { V3XandrCurateConfiguration } from '../models/V3XandrCurateConfiguration';
import { V3XandrInvestConfiguration } from '../models/V3XandrInvestConfiguration';
import { ObservableAdvertisingPlatformServiceApi } from './ObservableAPI';

import { AdvertisingPlatformServiceApiRequestFactory, AdvertisingPlatformServiceApiResponseProcessor} from "../apis/AdvertisingPlatformServiceApi";
export class PromiseAdvertisingPlatformServiceApi {
    private api: ObservableAdvertisingPlatformServiceApi

    public constructor(
        configuration: Configuration,
        requestFactory?: AdvertisingPlatformServiceApiRequestFactory,
        responseProcessor?: AdvertisingPlatformServiceApiResponseProcessor
    ) {
        this.api = new ObservableAdvertisingPlatformServiceApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param deal 
     */
    public advertisingPlatformServiceCreateXandrDeal(deal: V3Deal, _options?: Configuration): Promise<V3Deal> {
        const result = this.api.advertisingPlatformServiceCreateXandrDeal(deal, _options);
        return result.toPromise();
    }

    /**
     * @param dealList 
     */
    public advertisingPlatformServiceCreateXandrDealList(dealList: V3DealList, _options?: Configuration): Promise<V3DealList> {
        const result = this.api.advertisingPlatformServiceCreateXandrDealList(dealList, _options);
        return result.toPromise();
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceDeleteXandrDeal(id: number, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteXandrDeal(id, _options);
        return result.toPromise();
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceDeleteXandrDealList(id: number, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteXandrDealList(id, _options);
        return result.toPromise();
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceGetXandrDeal(id: number, _options?: Configuration): Promise<V3Deal> {
        const result = this.api.advertisingPlatformServiceGetXandrDeal(id, _options);
        return result.toPromise();
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceGetXandrLanguage(id: number, _options?: Configuration): Promise<V3Language> {
        const result = this.api.advertisingPlatformServiceGetXandrLanguage(id, _options);
        return result.toPromise();
    }

    /**
     * @param id 
     */
    public advertisingPlatformServiceGetXandrRegion(id: number, _options?: Configuration): Promise<V3Region> {
        const result = this.api.advertisingPlatformServiceGetXandrRegion(id, _options);
        return result.toPromise();
    }

    /**
     * @param name View a deal list by name and deals it contain.
     * @param id View a specific deal list and deals it contain.
     * @param advertiserId View a deal list by advertiser id and deals it contain.
     * @param dealId View all deal lists containing a deal.
     * @param search Search a deal list by id or name as search term.
     * @param lineItemId View all deal lists targeted by a line item.
     */
    public advertisingPlatformServiceListXandrDealLists(name?: string, id?: number, advertiserId?: number, dealId?: number, search?: string, lineItemId?: number, _options?: Configuration): Promise<V3ListXandrDealListsResponse> {
        const result = this.api.advertisingPlatformServiceListXandrDealLists(name, id, advertiserId, dealId, search, lineItemId, _options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceListXandrDeals(_options?: Configuration): Promise<V3ListXandrDealsResponse> {
        const result = this.api.advertisingPlatformServiceListXandrDeals(_options);
        return result.toPromise();
    }

    /**
     * @param search 
     * @param name 
     */
    public advertisingPlatformServiceListXandrLanguages(search?: string, name?: string, _options?: Configuration): Promise<V3ListXandrLanguagesResponse> {
        const result = this.api.advertisingPlatformServiceListXandrLanguages(search, name, _options);
        return result.toPromise();
    }

    /**
     * @param name 
     * @param code 
     */
    public advertisingPlatformServiceListXandrRegions(name?: string, code?: string, _options?: Configuration): Promise<V3ListXandrRegionsResponse> {
        const result = this.api.advertisingPlatformServiceListXandrRegions(name, code, _options);
        return result.toPromise();
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceRebuildGlobalSearch(body: V1RebuildGlobalSearchRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceRebuildGlobalSearch(body, _options);
        return result.toPromise();
    }

    /**
     * Resolve a segmentor incident and automatically redeploy affected segments
     * @param body 
     */
    public advertisingPlatformServiceResolveSegmentorIncident(body: any, _options?: Configuration): Promise<V3ResolveSegmentorIncidentResponse> {
        const result = this.api.advertisingPlatformServiceResolveSegmentorIncident(body, _options);
        return result.toPromise();
    }

    /**
     * Start a segmentor incident (triggered by monitoring alerts or manually)
     * @param body 
     */
    public advertisingPlatformServiceStartSegmentorIncident(body: V3StartSegmentorIncidentRequest, _options?: Configuration): Promise<V3StartSegmentorIncidentResponse> {
        const result = this.api.advertisingPlatformServiceStartSegmentorIncident(body, _options);
        return result.toPromise();
    }

    /**
     * @param deal 
     */
    public advertisingPlatformServiceUpdateXandrDeal(deal: V3Deal, _options?: Configuration): Promise<V3Deal> {
        const result = this.api.advertisingPlatformServiceUpdateXandrDeal(deal, _options);
        return result.toPromise();
    }

    /**
     * @param dealList 
     */
    public advertisingPlatformServiceUpdateXandrDealList(dealList: V3DealList, _options?: Configuration): Promise<V3DealList> {
        const result = this.api.advertisingPlatformServiceUpdateXandrDealList(dealList, _options);
        return result.toPromise();
    }


}



import { ObservableAssetsApi } from './ObservableAPI';

import { AssetsApiRequestFactory, AssetsApiResponseProcessor} from "../apis/AssetsApi";
export class PromiseAssetsApi {
    private api: ObservableAssetsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: AssetsApiRequestFactory,
        responseProcessor?: AssetsApiResponseProcessor
    ) {
        this.api = new ObservableAssetsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Permanently removes an asset from an org
     * Delete an Asset
     * @param assetId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteAsset(assetId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteAsset(assetId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get an Asset from an Asset ID
     * Get Asset
     * @param assetId The ID of the Asset to retrieve.
     * @param orgId The ID of the Organization.
     */
    public advertisingPlatformServiceGetAsset(assetId: string, orgId: string, _options?: Configuration): Promise<V1Asset> {
        const result = this.api.advertisingPlatformServiceGetAsset(assetId, orgId, _options);
        return result.toPromise();
    }

    /**
     * List Assets
     * @param pageSize The maximum number of assets to return. The service may return fewer than this value.  If unspecified, at most &#x60;100&#x60; assets will be returned.  The maximum value is &#x60;100&#x60;; values above &#x60;100&#x60; will be coerced to &#x60;100&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAssets&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAssets&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListAssets(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListAssetsResponse> {
        const result = this.api.advertisingPlatformServiceListAssets(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Update Asset
     * @param assetId ID of the asset
     * @param asset 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateAsset(assetId: string, asset: AdvertisingPlatformServiceUpdateAssetRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1Asset> {
        const result = this.api.advertisingPlatformServiceUpdateAsset(assetId, asset, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Streams a single image file
     * Upload Asset
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadAsset(body: V1UploadAssetRequest, _options?: Configuration): Promise<V1Asset> {
        const result = this.api.advertisingPlatformServiceUploadAsset(body, _options);
        return result.toPromise();
    }


}



import { ObservableAudienceAutomationsApi } from './ObservableAPI';

import { AudienceAutomationsApiRequestFactory, AudienceAutomationsApiResponseProcessor} from "../apis/AudienceAutomationsApi";
export class PromiseAudienceAutomationsApi {
    private api: ObservableAudienceAutomationsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: AudienceAutomationsApiRequestFactory,
        responseProcessor?: AudienceAutomationsApiResponseProcessor
    ) {
        this.api = new ObservableAudienceAutomationsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * ### Description Creates an Automation as a subresource of a Job. An Automation holds information used to automate recurring actions related to the job.  ### Key Points - **Allowed Product Types:** Currently, only audiences with the product type `PRODUCT_TYPE_PROSPECTING` can have automations. - **Deletion:** Deletion of automations is not supported at this time. - **Disabling Automations:** If you want to stop an automation from running, set `enabled` to `false` using the `UpdateAudienceAutomation` endpoint. - **Requoting Audiences:** Automations that requote an audience will only run if the audience has been generated at least once. - **Prospecting Audiences:** Automations for prospecting audiences will not run instantly; they will be queued in the default queue because their child audiences need to be quoted first.
     * Create  Audience Automation
     * @param audienceId The Audience this automation belongs to.
     * @param orgId The Organization where this Audience belongs to.
     * @param automation The automation to create.
     */
    public advertisingPlatformServiceCreateAudienceAutomation(audienceId: string, orgId: string, automation: V1Automation, _options?: Configuration): Promise<V1Automation> {
        const result = this.api.advertisingPlatformServiceCreateAudienceAutomation(audienceId, orgId, automation, _options);
        return result.toPromise();
    }

    /**
     * Update Audience Automation
     * @param audienceId The Audience to which this automation belongs.
     * @param automationId The Automation&#39;s ID.
     * @param orgId The Organization to which this Audience belongs.
     * @param automation The automation to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateAudienceAutomation(audienceId: string, automationId: string, orgId: string, automation: TheAutomationToUpdate, updateMask?: string, _options?: Configuration): Promise<V1Automation> {
        const result = this.api.advertisingPlatformServiceUpdateAudienceAutomation(audienceId, automationId, orgId, automation, updateMask, _options);
        return result.toPromise();
    }


}



import { ObservableAudiencesApi } from './ObservableAPI';

import { AudiencesApiRequestFactory, AudiencesApiResponseProcessor} from "../apis/AudiencesApi";
export class PromiseAudiencesApi {
    private api: ObservableAudiencesApi

    public constructor(
        configuration: Configuration,
        requestFactory?: AudiencesApiRequestFactory,
        responseProcessor?: AudiencesApiResponseProcessor
    ) {
        this.api = new ObservableAudiencesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Cancel Audience Generation
     * @param body 
     */
    public advertisingPlatformServiceCancelAudienceGeneration(body: V1CancelAudienceGenerationRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceCancelAudienceGeneration(body, _options);
        return result.toPromise();
    }

    /**
     * Clone Audience
     * @param body 
     */
    public advertisingPlatformServiceCloneAudience(body: V1CloneAudienceRequest, _options?: Configuration): Promise<Targetjobservicev1Audience> {
        const result = this.api.advertisingPlatformServiceCloneAudience(body, _options);
        return result.toPromise();
    }

    /**
     * ### Description: This endpoint defines the audience that will be processed on your target. The time it takes to move to the next phase can vary based on audience generation complexity and other factors. It is recommended that the client calls the **GET audiences** endpoint to check if the audience is ready to move to the next phase, such as generating. This process may involve monitoring the status for several minutes, depending on the processing time of the audience job.  ### Expected Response: - **Status Code**: 200 or 202 - **Response Body**: Includes the JSON key `'status': 'AUDIENCE_STATUS_CREATING'`, indicating that the audience job is being created.  ### Unexpected Responses and scenarios: #### 500 (Internal Server Error): - **Action**: Wait briefly and retry once. - **Exponential Backoff**: If the issue persists after the retry, use an exponential backoff strategy (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If still unresolved, submit a support ticket to ElToro, including the request CURL and file.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff with increasing delay (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL and file.  #### 400 (Bad Request): - **Action**: Do not retry. Troubleshoot the request to resolve the issue before submitting again.  #### AUDIENCE_STATUS_ERRORED: - **Action**: Troubleshoot the request or file for issues. - **Escalation**: If the issue is not resolved, submit a support ticket with the audience ID and org ID.  #### AUDIENCE_STATUS_CREATING remains for more than 5 minutes: - **Action**: If the audience remains in this status without further progress for over 5 minutes, submit a support ticket to ElToro with the audience and org ID.  **Recommended polling strategy**: Use exponential backoff with increasing delay: - **Initial Delay**: Start with a 5-second delay between requests. - **Subsequent Delays**: Increase the delay progressively, e.g., 10s, 20s, 40s, up to 60s. - **Reset on Update**: After receiving an update, reset the delay to the initial 5-second interval for further polling.  ### Expected Status Progression: - **AUDIENCE_STATUS_CREATING**: Audience is in the creation phase. - **AUDIENCE_STATUS_CREATED**: The audience has been successfully created and is ready to move to the next phase (e.g., generating).  
     * Create Audience
     * @param orgId The Organization where this audience will be created.
     * @param audience The audience to create.
     */
    public advertisingPlatformServiceCreateAudience(orgId: string, audience: Targetjobservicev1Audience, _options?: Configuration): Promise<Targetjobservicev1Audience> {
        const result = this.api.advertisingPlatformServiceCreateAudience(orgId, audience, _options);
        return result.toPromise();
    }

    /**
     * Create Audience Note
     * @param audienceId The Audience this note belongs to.
     * @param orgId The Organization where this Audience belongs to.
     * @param note The note to create.
     */
    public advertisingPlatformServiceCreateAudienceNote(audienceId: string, orgId: string, note: Targetjobservicev1Note, _options?: Configuration): Promise<Targetjobservicev1Note> {
        const result = this.api.advertisingPlatformServiceCreateAudienceNote(audienceId, orgId, note, _options);
        return result.toPromise();
    }

    /**
     * Delete Audience
     * @param audienceId The ID of the audience to delete.
     * @param orgId The Organization where this Audience belongs to.
     */
    public advertisingPlatformServiceDeleteAudience(audienceId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteAudience(audienceId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete Audience Note
     * @param audienceId The Audience this note belongs to.
     * @param noteId The id of the note to delete.
     * @param orgId The Organization where this Audience belongs to.
     */
    public advertisingPlatformServiceDeleteAudienceNote(audienceId: string, noteId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteAudienceNote(audienceId, noteId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Download Audience File
     * @param audienceId The ID of the audience.
     * @param audienceFileType File type to download.   - AUDIENCE_FILE_TYPE_UNKNOWN: Unknown File Type.  - AUDIENCE_FILE_TYPE_ANNOTATED: File of the original source file data with a boolean that specifies whether the row was matched or not.  - AUDIENCE_FILE_TYPE_SELECTED: File of the ip addresses and ethashs.  - AUDIENCE_FILE_TYPE_VALIDATED: File of the validated addresses.  - AUDIENCE_FILE_TYPE_RESULTS: File of the results of digital canvas.  - AUDIENCE_FILE_TYPE_DIRECT_MAIL: File of direct mail addresses.  - AUDIENCE_FILE_TYPE_HOMES: File of the addresses of devices found in venue replay.  - AUDIENCE_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN: File of the devices found in homes but not found with venue replay.  - AUDIENCE_FILE_TYPE_DEVICES_WITH_HOMES: File of the devices with homes found in venue replay.  - AUDIENCE_FILE_TYPE_DEVICES_WITHOUT_HOMES: File of the devices without homes found in venue replay.  - AUDIENCE_FILE_TYPE_MAIDS: File of MAIDS addresses.  - AUDIENCE_FILE_TYPE_ENRICHED: File of Enriched addresses.
     * @param orgId The ID of the target&#39;s org
     */
    public advertisingPlatformServiceDownloadAudienceFile(audienceId?: string, audienceFileType?: 'AUDIENCE_FILE_TYPE_UNKNOWN' | 'AUDIENCE_FILE_TYPE_ANNOTATED' | 'AUDIENCE_FILE_TYPE_SELECTED' | 'AUDIENCE_FILE_TYPE_VALIDATED' | 'AUDIENCE_FILE_TYPE_RESULTS' | 'AUDIENCE_FILE_TYPE_DIRECT_MAIL' | 'AUDIENCE_FILE_TYPE_HOMES' | 'AUDIENCE_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN' | 'AUDIENCE_FILE_TYPE_DEVICES_WITH_HOMES' | 'AUDIENCE_FILE_TYPE_DEVICES_WITHOUT_HOMES' | 'AUDIENCE_FILE_TYPE_MAIDS' | 'AUDIENCE_FILE_TYPE_ENRICHED', orgId?: string, _options?: Configuration): Promise<StreamResultOfV1DownloadAudienceFileResponse> {
        const result = this.api.advertisingPlatformServiceDownloadAudienceFile(audienceId, audienceFileType, orgId, _options);
        return result.toPromise();
    }

    /**
     * ### Description: The `generate` endpoint initiates the job to process the specified audience. The time required for this stage can vary significantly, depending on factors such as the job type and the size of the target file. Once the job is triggered, it is essential to monitor its progress using the `GET audiences` endpoint.  ---  ### Expected Response: - **Status Code**: 200 or 202 - **Response Body**: Includes the JSON key `'status': 'AUDIENCE_STATUS_QUEUED'`, indicating that the audience has been successfully added to the processing queue.  ---  ### Unexpected Responses: #### 500 (Internal Server Error): - **Action**: Perform a short wait and retry once. - **Escalation**: If the issue persists, submit a support ticket to ElToro, including the request CURL and associated file.  #### 503 (Service Unavailable): - **Action**: Retry the request up to 4 times using exponential backoff (e.g., wait 1s, 2s, 4s, 8s between retries). - **Escalation**: If unresolved, submit a ticket to ElToro with the request CURL and file.  #### Other Status Codes (e.g., 400): - **Action**: Do not retry. Investigate and troubleshoot the request before attempting again.  #### AUDIENCE_STATUS_ERRORED: - **Action**: Submit a support ticket with the audience ID and org ID for investigation.  #### Status remains `AUDIENCE_STATUS_RUNNING` or `AUDIENCE_STATUS_QUEUED` for more than 60 minutes: - **Action**: Submit a ticket to ElToro with the audience ID and org ID.  ---  ### Recommended Polling Strategy: - **Initial Delay**: Begin polling with an initial delay of 5 seconds. - **Subsequent Delays**: Gradually increase the delay up to a maximum of 60 seconds between retries. - **Reset Backoff**: Reset the backoff once a response indicates a status transition.  ---  ### Expected Status Progression: - **AUDIENCE_STATUS_QUEUED**: Indicates the job is in the queue, awaiting execution. - **AUDIENCE_STATUS_RUNNING**: Confirms the job is actively being processed. - **AUDIENCE_STATUS_COMPLETED**: The audience generation job is finished, and results can be downloaded. - **AUDIENCE_STATUS_READY**: The audience is finalized and can be added to an order line. 
     * Generate Audience
     * @param audienceId The ID of the Audience.
     * @param orgId The ID of the Org associated to the Audience.
     * @param version (OPTIONAL) The version of the target file to use. If empty, the most recent version is used.
     * @param queryId (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param seenCount (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param locType (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param radius (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryType (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryArgs (OPTIONAL) Additional field you might need in order to run a job.
     */
    public advertisingPlatformServiceGenerateAudience(audienceId?: string, orgId?: string, version?: number, queryId?: string, seenCount?: number, locType?: string, radius?: number, queryType?: string, queryArgs?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceGenerateAudience(audienceId, orgId, version, queryId, seenCount, locType, radius, queryType, queryArgs, _options);
        return result.toPromise();
    }

    /**
     * #### Description: Endpoint used to get the Audience Resource.  ---  ### Unexpected Scenarios: #### 500 (Internal Server Error): - **Action**: Perform a short wait and retry once. - **Escalation**: If unresolved, submit a ticket to ElToro with the request details.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff. - **Escalation**: If unresolved, submit a ticket with the request details.  ---  ### Exponential Backoff Example: - **Initial Delay**: 5 seconds - **Subsequent Delays**: 10s, 20s, 40s (up to a maximum of 60s). - **Reset Backoff**: After a successful response or status update, return to the initial delay for future polling.  Using exponential backoff helps balance timely updates with system efficiency, reducing unnecessary load on both client and server resources. This strategy ensures a balance between not overloading the server with excessive polling and allowing enough time for the system to recover from temporary issues. 
     * Get Audience
     * @param audienceId The ID of the audience to retrieve.
     * @param orgId The Organization where this Audience belongs to.
     */
    public advertisingPlatformServiceGetAudience(audienceId: string, orgId: string, _options?: Configuration): Promise<Targetjobservicev1Audience> {
        const result = this.api.advertisingPlatformServiceGetAudience(audienceId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get Queue Health
     */
    public advertisingPlatformServiceGetQueueHealth(_options?: Configuration): Promise<V1QueueHealth> {
        const result = this.api.advertisingPlatformServiceGetQueueHealth(_options);
        return result.toPromise();
    }

    /**
     * List Audience Folders
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCreatives&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreatives&#x60; must match the request that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListAudienceFolders(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListAudienceFoldersResponse> {
        const result = this.api.advertisingPlatformServiceListAudienceFolders(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List Audiences
     * @param pageSize The maximum number of audiences to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; audiences will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAudiences&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAudiences&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return audiences of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListAudiences(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Promise<V1ListAudiencesResponse> {
        const result = this.api.advertisingPlatformServiceListAudiences(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);
        return result.toPromise();
    }

    /**
     * List Audiences attached to order lines wih refresh enabled true
     * @param pageSize The maximum number of audiences to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; audiences will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAudiences&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAudiences&#x60; must match the call that provided the page token.
     */
    public advertisingPlatformServiceListOrderlineAttachedRefreshAudiences(pageSize?: number, pageToken?: string, _options?: Configuration): Promise<V1ListAudiencesResponse> {
        const result = this.api.advertisingPlatformServiceListOrderlineAttachedRefreshAudiences(pageSize, pageToken, _options);
        return result.toPromise();
    }

    /**
     * Update Audience
     * @param audienceId The Audience ID.
     * @param orgId The Organization where this Audience belongs to.
     * @param audience The audience to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateAudience(audienceId: string, orgId: string, audience: TheAudienceToUpdate, updateMask?: string, _options?: Configuration): Promise<Targetjobservicev1Audience> {
        const result = this.api.advertisingPlatformServiceUpdateAudience(audienceId, orgId, audience, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update Audience Note
     * @param audienceId The Audience this note belongs to.
     * @param noteId The Note ID.
     * @param orgId The Organization where this Audience belongs to.
     * @param note The note to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateAudienceNote(audienceId: string, noteId: string, orgId: string, note: TheNoteToUpdate, updateMask?: string, _options?: Configuration): Promise<Targetjobservicev1Note> {
        const result = this.api.advertisingPlatformServiceUpdateAudienceNote(audienceId, noteId, orgId, note, updateMask, _options);
        return result.toPromise();
    }


}



import { ObservableAuditApi } from './ObservableAPI';

import { AuditApiRequestFactory, AuditApiResponseProcessor} from "../apis/AuditApi";
export class PromiseAuditApi {
    private api: ObservableAuditApi

    public constructor(
        configuration: Configuration,
        requestFactory?: AuditApiRequestFactory,
        responseProcessor?: AuditApiResponseProcessor
    ) {
        this.api = new ObservableAuditApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Audits objects deployed out to DSPs
     * Audit
     * @param body 
     */
    public advertisingPlatformServiceAudit(body: any, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceAudit(body, _options);
        return result.toPromise();
    }


}



import { ObservableAuthenticationApi } from './ObservableAPI';

import { AuthenticationApiRequestFactory, AuthenticationApiResponseProcessor} from "../apis/AuthenticationApi";
export class PromiseAuthenticationApi {
    private api: ObservableAuthenticationApi

    public constructor(
        configuration: Configuration,
        requestFactory?: AuthenticationApiRequestFactory,
        responseProcessor?: AuthenticationApiResponseProcessor
    ) {
        this.api = new ObservableAuthenticationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * OAuth 2.0
     * @param body 
     */
    public advertisingPlatformServiceOAuthToken(body: V1OAuthTokenRequest, _options?: Configuration): Promise<V1JWT> {
        const result = this.api.advertisingPlatformServiceOAuthToken(body, _options);
        return result.toPromise();
    }


}



import { ObservableBillingApi } from './ObservableAPI';

import { BillingApiRequestFactory, BillingApiResponseProcessor} from "../apis/BillingApi";
export class PromiseBillingApi {
    private api: ObservableBillingApi

    public constructor(
        configuration: Configuration,
        requestFactory?: BillingApiRequestFactory,
        responseProcessor?: BillingApiResponseProcessor
    ) {
        this.api = new ObservableBillingApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Add  a note to orgs that have no valid associated credit cards
     */
    public advertisingPlatformServiceAddNoteToOrgsWithoutValidCCs(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceAddNoteToOrgsWithoutValidCCs(_options);
        return result.toPromise();
    }

    /**
     * Create a credit card
     * @param creditCardOrgId ID of the Org the credit card belongs to
     * @param body 
     */
    public advertisingPlatformServiceCreateCreditCard(creditCardOrgId: string, body: CreateCreditCardRequest, _options?: Configuration): Promise<V1CreditCard> {
        const result = this.api.advertisingPlatformServiceCreateCreditCard(creditCardOrgId, body, _options);
        return result.toPromise();
    }

    /**
     * Create Invoice
     * @param orgId 
     * @param adminInvoice 
     */
    public advertisingPlatformServiceCreateInvoice(orgId: string, adminInvoice: V1AdminInvoice, _options?: Configuration): Promise<V1AdminInvoice> {
        const result = this.api.advertisingPlatformServiceCreateInvoice(orgId, adminInvoice, _options);
        return result.toPromise();
    }

    /**
     * Delete a credit card
     * @param orgId ID of the Org the credit card belongs to
     * @param creditCardId ID of the credit to be deleted
     */
    public advertisingPlatformServiceDeleteCreditCard(orgId: string, creditCardId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteCreditCard(orgId, creditCardId, _options);
        return result.toPromise();
    }

    /**
     * Delete an invoice by id
     * @param id 
     */
    public advertisingPlatformServiceDeleteInvoice(id: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteInvoice(id, _options);
        return result.toPromise();
    }

    /**
     * Get accounting job
     * @param jobId ID of the Job
     */
    public advertisingPlatformServiceGetAccountingJob(jobId: string, _options?: Configuration): Promise<V1AccountingJob> {
        const result = this.api.advertisingPlatformServiceGetAccountingJob(jobId, _options);
        return result.toPromise();
    }

    /**
     * Get the balance of an org
     * @param orgId ID of the Org to get the balance for
     */
    public advertisingPlatformServiceGetBalance(orgId: string, _options?: Configuration): Promise<V1Balance> {
        const result = this.api.advertisingPlatformServiceGetBalance(orgId, _options);
        return result.toPromise();
    }

    /**
     * Get billing information for an org
     * @param orgId 
     * @param includeInvoices include_invoices
     * @param includeBalance include_balance
     * @param invoiceStatus invoice_status  Filter based on the invoices statuses.
     */
    public advertisingPlatformServiceGetBillingOrg(orgId: string, includeInvoices?: boolean, includeBalance?: boolean, invoiceStatus?: 'INVOICE_STATUS_UNKNOWN' | 'INVOICE_STATUS_PAID' | 'INVOICE_STATUS_PROCESSING' | 'INVOICE_STATUS_DECLINED' | 'INVOICE_STATUS_PAYMENT_DUE' | 'INVOICE_STATUS_PARTIALLY_PAID' | 'INVOICE_STATUS_PAST_DUE', _options?: Configuration): Promise<Billingservicev1Org> {
        const result = this.api.advertisingPlatformServiceGetBillingOrg(orgId, includeInvoices, includeBalance, invoiceStatus, _options);
        return result.toPromise();
    }

    /**
     * Get information around a commission group
     * Get information around a commission group
     * @param recordNo Commission group
     */
    public advertisingPlatformServiceGetCommissionGroup(recordNo: string, _options?: Configuration): Promise<Billingservicev1CommissionGroup> {
        const result = this.api.advertisingPlatformServiceGetCommissionGroup(recordNo, _options);
        return result.toPromise();
    }

    /**
     * Get credit card information
     * @param orgId ID of the Org that the credit card is associated with
     * @param creditCardId ID of the credit card
     */
    public advertisingPlatformServiceGetCreditCard(orgId: string, creditCardId: string, _options?: Configuration): Promise<V1CreditCard> {
        const result = this.api.advertisingPlatformServiceGetCreditCard(orgId, creditCardId, _options);
        return result.toPromise();
    }

    /**
     * Get invoice on an org
     * Get a specific invoice from an org
     * @param orgId Id of the org that owns the invoices
     * @param recordNo Number (id) of the invoice
     */
    public advertisingPlatformServiceGetInvoice(orgId: string, recordNo: string, _options?: Configuration): Promise<Billingservicev1Invoice> {
        const result = this.api.advertisingPlatformServiceGetInvoice(orgId, recordNo, _options);
        return result.toPromise();
    }

    /**
     * List accounting jobs
     * @param pageSize The maximum number of jobs to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; jobs will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListAccountingJobs&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAccountingJobs&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListAccountingJobs(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListAccountingJobsResponse> {
        const result = this.api.advertisingPlatformServiceListAccountingJobs(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List commission groups
     * List commission groups
     */
    public advertisingPlatformServiceListCommissionGroups(_options?: Configuration): Promise<V1ListCommissionGroupsResponse> {
        const result = this.api.advertisingPlatformServiceListCommissionGroups(_options);
        return result.toPromise();
    }

    /**
     * List credit cards
     * @param orgId The org associated with the listed credit cards
     * @param pageSize How many credit cards to return in the response
     * @param pageToken page_token  A token received by prior list calls, used to send on subsequent list requests to retrieve next page of credit cards
     * @param orderBy How to order the credit cards returning
     * @param filter Filter
     */
    public advertisingPlatformServiceListCreditCards(orgId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListCreditCardsResponse> {
        const result = this.api.advertisingPlatformServiceListCreditCards(orgId, pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List all invoices on an org
     * Get all invoices from an org
     * @param orgId Id of the org that owns the invoices
     * @param status status  Filter based on the invoices statuses.
     */
    public advertisingPlatformServiceListInvoices(orgId: string, status?: 'INVOICE_STATUS_UNKNOWN' | 'INVOICE_STATUS_PAID' | 'INVOICE_STATUS_PROCESSING' | 'INVOICE_STATUS_DECLINED' | 'INVOICE_STATUS_PAYMENT_DUE' | 'INVOICE_STATUS_PARTIALLY_PAID' | 'INVOICE_STATUS_PAST_DUE', _options?: Configuration): Promise<Billingservicev1ListInvoicesResponse> {
        const result = this.api.advertisingPlatformServiceListInvoices(orgId, status, _options);
        return result.toPromise();
    }

    /**
     * List all invoices on an org
     * @param orgId Id of the org that owns the invoices
     * @param pageSize How many invoices to return in the response
     * @param pageToken page_token  A token received by prior list calls, used to send on subsequent list requests to retrieve next page of credit cards
     * @param orderBy How to order the invoices returning
     * @param filter Filter
     */
    public advertisingPlatformServiceListInvoicesV2(orgId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<Billingservicev2ListInvoicesResponse> {
        const result = this.api.advertisingPlatformServiceListInvoicesV2(orgId, pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Pay an invoice for an org
     * Pay a specific invoice for an org
     * @param orgId Id of the org that owns the invoices
     * @param id ID of the invoice
     * @param body 
     */
    public advertisingPlatformServicePayInvoice(orgId: string, id: string, body: PayInvoiceRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServicePayInvoice(orgId, id, body, _options);
        return result.toPromise();
    }

    /**
     * Pay the setup fee of an org
     * @param orgId ID of the Org to pay the set-up fee for
     * @param body 
     */
    public advertisingPlatformServicePaySetupFee(orgId: string, body: PaySetUpFeeRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServicePaySetupFee(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Prepay an org
     * @param orgId ID of the Org to prepay
     * @param body 
     */
    public advertisingPlatformServicePrepay(orgId: string, body: PrepayRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServicePrepay(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Remove Orgs Billing Hold
     */
    public advertisingPlatformServiceRemoveOrgsBillingHold(_options?: Configuration): Promise<V1CronResponse> {
        const result = this.api.advertisingPlatformServiceRemoveOrgsBillingHold(_options);
        return result.toPromise();
    }

    /**
     * Run commissions
     * Run commissions for all orgs
     * @param body 
     */
    public advertisingPlatformServiceRunCommissions(body: V1RunCommissionsRequest, _options?: Configuration): Promise<V1RunCommissionsResponse> {
        const result = this.api.advertisingPlatformServiceRunCommissions(body, _options);
        return result.toPromise();
    }

    /**
     * Run invoicing
     * Run invoicing for all orgs
     * @param body 
     */
    public advertisingPlatformServiceRunInvoicing(body: V1RunInvoicingRequest, _options?: Configuration): Promise<V1RunInvoicingResponse> {
        const result = this.api.advertisingPlatformServiceRunInvoicing(body, _options);
        return result.toPromise();
    }

    /**
     * Send out expired credit card emails
     */
    public advertisingPlatformServiceSendExpiredCreditCardEmails(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceSendExpiredCreditCardEmails(_options);
        return result.toPromise();
    }

    /**
     * Send emails to all clients with overdue invoices
     */
    public advertisingPlatformServiceSendOverdueInvoiceEmails(_options?: Configuration): Promise<V1CronResponse> {
        const result = this.api.advertisingPlatformServiceSendOverdueInvoiceEmails(_options);
        return result.toPromise();
    }

    /**
     * Sync billing service credit cards with AuthNet
     */
    public advertisingPlatformServiceSyncOrgCCsWithAuthnet(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceSyncOrgCCsWithAuthnet(_options);
        return result.toPromise();
    }

    /**
     * Syncs sage invoices to db
     */
    public advertisingPlatformServiceSyncSageInvoicesToDB(_options?: Configuration): Promise<V1CronResponse> {
        const result = this.api.advertisingPlatformServiceSyncSageInvoicesToDB(_options);
        return result.toPromise();
    }

    /**
     * Update a credit card's info
     * @param creditCardOrgId ID of the Org the credit card belongs to
     * @param creditCardId ID of the credit card
     * @param creditCard Credit Card  Information needed to process a credit card
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateCreditCard(creditCardOrgId: string, creditCardId: string, creditCard: CreditCard1, updateMask?: string, _options?: Configuration): Promise<V1CreditCard> {
        const result = this.api.advertisingPlatformServiceUpdateCreditCard(creditCardOrgId, creditCardId, creditCard, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Web To Home Billing
     */
    public advertisingPlatformServiceWebToHomeBilling(_options?: Configuration): Promise<V1CronResponse> {
        const result = this.api.advertisingPlatformServiceWebToHomeBilling(_options);
        return result.toPromise();
    }


}



import { ObservableCallbacksApi } from './ObservableAPI';

import { CallbacksApiRequestFactory, CallbacksApiResponseProcessor} from "../apis/CallbacksApi";
export class PromiseCallbacksApi {
    private api: ObservableCallbacksApi

    public constructor(
        configuration: Configuration,
        requestFactory?: CallbacksApiRequestFactory,
        responseProcessor?: CallbacksApiResponseProcessor
    ) {
        this.api = new ObservableCallbacksApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Callback to a url
     * Callback to a service
     * @param jwt JWT  The JWT Token holding the info necessary to callback to service required
     * @param orgId 
     * @param requestId Request_ID  Id of the request
     */
    public advertisingPlatformServiceCallback(jwt?: string, orgId?: string, requestId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceCallback(jwt, orgId, requestId, _options);
        return result.toPromise();
    }


}



import { ObservableCampaignsApi } from './ObservableAPI';

import { CampaignsApiRequestFactory, CampaignsApiResponseProcessor} from "../apis/CampaignsApi";
export class PromiseCampaignsApi {
    private api: ObservableCampaignsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: CampaignsApiRequestFactory,
        responseProcessor?: CampaignsApiResponseProcessor
    ) {
        this.api = new ObservableCampaignsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Add Audience
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceAddAudience(orderLineId: string, body: AddAudienceRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceAddAudience(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Add Creative
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceAddCreative(orderLineId: string, body: AddCreativeRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceAddCreative(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceAppendOrderLineNote(orderLineId: string, body: AdvertisingPlatformServiceAppendOrderLineNoteRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceAppendOrderLineNote(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Approves an order line
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceApproveOrderLine(orderLineId: string, body: ApproveOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceApproveOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Archive Campaign
     * @param body 
     */
    public advertisingPlatformServiceArchiveCampaign(body: V1ArchiveCampaignRequest, _options?: Configuration): Promise<Campaignservicev1Campaign> {
        const result = this.api.advertisingPlatformServiceArchiveCampaign(body, _options);
        return result.toPromise();
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceArchiveOrderLine(body: V1ArchiveOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceArchiveOrderLine(body, _options);
        return result.toPromise();
    }

    /**
     * Batch Add Audiences
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchAddAudiences(orderLineId: string, body: AdvertisingPlatformServiceBatchAddAudiencesRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceBatchAddAudiences(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Batch Add Creatives
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchAddCreatives(orderLineId: string, body: AdvertisingPlatformServiceBatchAddCreativesRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceBatchAddCreatives(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Batch Remove Audiences
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchRemoveAudiences(orderLineId: string, body: AdvertisingPlatformServiceBatchRemoveAudiencesRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceBatchRemoveAudiences(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Batch Remove Creatives
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceBatchRemoveCreatives(orderLineId: string, body: AdvertisingPlatformServiceBatchRemoveCreativesRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceBatchRemoveCreatives(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Batch Update OrderLines
     * @param body 
     */
    public advertisingPlatformServiceBatchUpdateOrderLines(body: V1BatchUpdateOrderLinesRequest, _options?: Configuration): Promise<V1BatchUpdateOrderLinesResponse> {
        const result = this.api.advertisingPlatformServiceBatchUpdateOrderLines(body, _options);
        return result.toPromise();
    }

    /**
     * Cancel OrderLine Deployment
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceCancelOrderLineDeployment(orderLineId: string, body: CancelOrderLineDeploymentRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceCancelOrderLineDeployment(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Clone OrderLine
     * @param orderLineId ID of the Order Line to clone.
     * @param body 
     */
    public advertisingPlatformServiceCloneOrderLine(orderLineId: string, body: AdvertisingPlatformServiceCloneOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceCloneOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Create a new Camapign
     * Create Campaign
     * @param orgId The Organization where this Campaign will be created.
     * @param campaign The campaign to create.
     */
    public advertisingPlatformServiceCreateCampaign(orgId: string, campaign: Campaignservicev1Campaign, _options?: Configuration): Promise<Campaignservicev1Campaign> {
        const result = this.api.advertisingPlatformServiceCreateCampaign(orgId, campaign, _options);
        return result.toPromise();
    }

    /**
     * Create one or more destination deployment configurations (DDCs) for an order line. When distribution exists, this configures destinations only; allocation values are managed by SetDistribution.
     * Create Deployment Configuration
     * @param orderLineId The ID of the Order Line being configured.
     * @param body 
     */
    public advertisingPlatformServiceCreateDeployment(orderLineId: string, body: CreateDeploymentRequest, _options?: Configuration): Promise<V3DeploymentDestinationConfigurations> {
        const result = this.api.advertisingPlatformServiceCreateDeployment(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Create a new OrderLine
     * Create OrderLine
     * @param orgId The organization where this order line will be created.
     * @param orderLine The order line to create.
     * @param campaignId The campaign that the OrderLine will be auto attached to.
     */
    public advertisingPlatformServiceCreateOrderLine(orgId: string, orderLine: Campaignservicev1OrderLine, campaignId?: string, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceCreateOrderLine(orgId, orderLine, campaignId, _options);
        return result.toPromise();
    }

    /**
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceDeactivateOrderLineNote(orderLineId: string, body: AdvertisingPlatformServiceDeactivateOrderLineNoteRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeactivateOrderLineNote(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Deletes a Campaign
     * Delete Campaign
     * @param campaignId ID of the Campaign
     * @param orgId The Organization where this Campaign belongs to.
     */
    public advertisingPlatformServiceDeleteCampaign(campaignId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteCampaign(campaignId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete OrderLine
     * @param orderLineId The ID of the order line to delete.
     * @param orgId The Organization where this creative belongs to.
     */
    public advertisingPlatformServiceDeleteOrderLine(orderLineId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteOrderLine(orderLineId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Deploy OrderLine to xandr invest
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceDeployOrderLine(orderLineId: string, body: DeployOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceDeployOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Get a Campaign by ID
     * Get Campaign
     * @param campaignId The ID of the campaign to retrieve.
     * @param orgId The Organization where this Campaign belongs to.
     */
    public advertisingPlatformServiceGetCampaign(campaignId: string, orgId: string, _options?: Configuration): Promise<Campaignservicev1Campaign> {
        const result = this.api.advertisingPlatformServiceGetCampaign(campaignId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get an OrderLine by ID
     * Get OrderLine
     * @param orderLineId The ID of the Order Line to retrieve.
     * @param orgId The ID of Organization that this Order Line belongs to.
     */
    public advertisingPlatformServiceGetOrderLine(orderLineId: string, orgId: string, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceGetOrderLine(orderLineId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get OrderLine Job
     * @param jobId The ID of the batch upsert job.
     * @param orgId The ID of Organization that this Job belongs to.
     */
    public advertisingPlatformServiceGetOrderLineJob(jobId: string, orgId?: string, _options?: Configuration): Promise<V1OrderLineJob> {
        const result = this.api.advertisingPlatformServiceGetOrderLineJob(jobId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get OrderLine Job
     * @param jobId The ID of the batch upsert job.
     * @param orgId The ID of Organization that this Job belongs to.
     */
    public advertisingPlatformServiceGetOrderLineJob2(jobId: string, orgId?: string, _options?: Configuration): Promise<V1OrderLineJob> {
        const result = this.api.advertisingPlatformServiceGetOrderLineJob2(jobId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get OrderLine Destination Configuration Default Template
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceGetTemplate(orderLineId: string, body: GetDefaultTemplateRequest, _options?: Configuration): Promise<V1GetTemplateResponse> {
        const result = this.api.advertisingPlatformServiceGetTemplate(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Get a Campaign History by ID
     * List CampaignEvents
     * @param campaignId ID of Campaign.
     * @param orgId ID of Org
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCampaignEvents&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCampaignEvents&#x60; must match the request that provided the page token.
     */
    public advertisingPlatformServiceListCampaignEvents(campaignId: string, orgId: string, pageSize?: number, pageToken?: string, _options?: Configuration): Promise<V1ListCampaignEventsResponse> {
        const result = this.api.advertisingPlatformServiceListCampaignEvents(campaignId, orgId, pageSize, pageToken, _options);
        return result.toPromise();
    }

    /**
     * List Campaigns
     * List Campaigns
     * @param pageSize The maximum number of campaigns to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; campaigns will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListCampaigns&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCampaigns&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return campaigns of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListCampaigns(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Promise<Campaignservicev1ListCampaignsResponse> {
        const result = this.api.advertisingPlatformServiceListCampaigns(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);
        return result.toPromise();
    }

    /**
     * Get a list of changes that have been made to an order line
     * List OrderLineEvents
     * @param orderLineId ID of OrderLine.
     * @param orgId ID of Org
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListOrderLineEvents&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrderLineEvents&#x60; must match the request that provided the page token.
     */
    public advertisingPlatformServiceListOrderLineEvents(orderLineId: string, orgId: string, pageSize?: number, pageToken?: string, _options?: Configuration): Promise<V1ListOrderLineEventsResponse> {
        const result = this.api.advertisingPlatformServiceListOrderLineEvents(orderLineId, orgId, pageSize, pageToken, _options);
        return result.toPromise();
    }

    /**
     * List OrderLine Jobs
     * @param template  - JOB_TEMPLATE_UNSPECIFIED: [id, name, org_id, campaign_id, impressions, impressions_per_day, ref_id, click_through_url, start_time, end_time, creative_ids, audience_ids] creative_ids and audience_ids use pipe delimeter  - JOB_TEMPLATE_AA_STANDARD: [org_id, start_time, end_time, pacing_strategy, campaign_impressions, click_through_url, creative_ids, seen_count, loc_type, dealer_zipcode, radius, dms_audience_id, control_audience_id]  - JOB_TEMPLATE_ADMIN_PORTAL_CREATE: [org_id, campaign_id, campaign_name, order_line_name, order_line_start_time, order_line_end_time, creative_ids, audience_ids, click_through_url, impressions, minimum_impressions, cpm]  - JOB_TEMPLATE_ADMIN_PORTAL_UPDATE: [org_id, campaign_id, campaign_name, order_line_id, order_line_name, order_line_start_time, order_line_end_time, creative_ids, audience_ids, click_through_url, impressions, minimum_impressions, cpm]
     */
    public advertisingPlatformServiceListOrderLineJobs(template?: 'JOB_TEMPLATE_UNSPECIFIED' | 'JOB_TEMPLATE_AA_STANDARD' | 'JOB_TEMPLATE_ADMIN_PORTAL_CREATE' | 'JOB_TEMPLATE_ADMIN_PORTAL_UPDATE', _options?: Configuration): Promise<V1ListOrderLineJobsResponse> {
        const result = this.api.advertisingPlatformServiceListOrderLineJobs(template, _options);
        return result.toPromise();
    }

    /**
     * Get a paginated list of all OrderLines
     * List OrderLines
     * @param pageSize The maximum number of order lines to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; order lines will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListOrderLines&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrderLines&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return order lines of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListOrderLines(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Promise<V1ListOrderLinesResponse> {
        const result = this.api.advertisingPlatformServiceListOrderLines(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);
        return result.toPromise();
    }

    /**
     * Lock an order line
     * @param orderLineId The ID of the Order Line to lock
     * @param body 
     */
    public advertisingPlatformServiceLockOrderLine(orderLineId: string, body: LockOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceLockOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Pause an OrderLine
     * @param orderLineId The ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServicePauseOrderLine(orderLineId: string, body: PauseOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServicePauseOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Pay Order Lines
     * Pay Order Lines
     * @param body 
     */
    public advertisingPlatformServicePayOrderLines(body: V1PayOrderLinesRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServicePayOrderLines(body, _options);
        return result.toPromise();
    }

    /**
     * Play an OrderLine
     * @param orderLineId id of the order line
     * @param body 
     */
    public advertisingPlatformServicePlayOrderLine(orderLineId: string, body: PlayOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServicePlayOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Rejects an order line
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceRejectOrderLine(orderLineId: string, body: RejectOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceRejectOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Remove Audience
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceRemoveAudience(orderLineId: string, body: RemoveAudienceRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceRemoveAudience(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Remove Creative
     * @param orderLineId The ID of the Order Line
     * @param body 
     */
    public advertisingPlatformServiceRemoveCreative(orderLineId: string, body: RemoveCreativeRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceRemoveCreative(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Request Review
     * @param orderLineId The OrderLine resource to submit for review.
     * @param body 
     */
    public advertisingPlatformServiceRequestReview(orderLineId: string, body: RequestReviewRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceRequestReview(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceSetCampaignPoliticalForm(body: V1SetCampaignPoliticalFormRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceSetCampaignPoliticalForm(body, _options);
        return result.toPromise();
    }

    /**
     * Create or update the order line impression allocation across destinations. If the order line is currently DEPLOYED, PAUSED, or SERVING, this operation auto-triggers a redeploy so allocation-driven budget changes are applied.
     * Set Distribution
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceSetDistribution(orderLineId: string, body: SetDistributionRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceSetDistribution(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceStartArchivingOrderLines(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceStartArchivingOrderLines(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceStartOrderLineStatusChecker(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceStartOrderLineStatusChecker(_options);
        return result.toPromise();
    }

    /**
     * Starts review on an order line
     * @param orderLineId ID of the Order Line.
     * @param body 
     */
    public advertisingPlatformServiceStartReview(orderLineId: string, body: StartReviewRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceStartReview(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceUnarchiveOrderLine(body: V1UnarchiveOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceUnarchiveOrderLine(body, _options);
        return result.toPromise();
    }

    /**
     * Unlock an order line
     * @param orderLineId The ID of the Order Line to unlock
     * @param body 
     */
    public advertisingPlatformServiceUnlockOrderLine(orderLineId: string, body: UnlockOrderLineRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceUnlockOrderLine(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Update Campaign
     * Update Campaign
     * @param campaignId ID of Campaign.
     * @param orgId The Organization where this Campaign belongs to.
     * @param campaign The campaign to update.
     * @param updateMask List of fields to be updated
     */
    public advertisingPlatformServiceUpdateCampaign(campaignId: string, orgId: string, campaign: TheCampaignToUpdate, updateMask?: string, _options?: Configuration): Promise<Campaignservicev1Campaign> {
        const result = this.api.advertisingPlatformServiceUpdateCampaign(campaignId, orgId, campaign, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update destination deployment configurations (DDCs). If distribution is active, budget/impression updates for allocated destinations are blocked and destination removal for allocated destinations is blocked.
     * Update Deployment Configuration
     * @param orderLineId The ID of the Order Line being set.
     * @param body 
     */
    public advertisingPlatformServiceUpdateDeployment(orderLineId: string, body: UpdateDeploymentRequest, _options?: Configuration): Promise<V3DeploymentDestinationConfigurations> {
        const result = this.api.advertisingPlatformServiceUpdateDeployment(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Update OrderLine
     * @param orderLineId ID of the Order Line.
     * @param orgId The Organization where this Order Line belongs to.
     * @param orderLine The order line to update.
     * @param updateMask Field Mask  The list of fields to update.
     */
    public advertisingPlatformServiceUpdateOrderLine(orderLineId: string, orgId: string, orderLine: TheOrderLineToUpdate, updateMask?: string, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceUpdateOrderLine(orderLineId, orgId, orderLine, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update the CPMs of an Order Line
     * Update  Order Line CPMs
     * @param orderLineId ID of the order line
     * @param body 
     */
    public advertisingPlatformServiceUpdateOrderLineCPMs(orderLineId: string, body: UpdateCPMsRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceUpdateOrderLineCPMs(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * @param orderLineId 
     * @param body 
     */
    public advertisingPlatformServiceUpdateOrderLineNote(orderLineId: string, body: AdvertisingPlatformServiceUpdateOrderLineNoteRequest, _options?: Configuration): Promise<Campaignservicev1OrderLine> {
        const result = this.api.advertisingPlatformServiceUpdateOrderLineNote(orderLineId, body, _options);
        return result.toPromise();
    }

    /**
     * Upload OrderLine Job
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadOrderLineJob(body: V1UploadOrderLineJobRequest, _options?: Configuration): Promise<V1OrderLineJob> {
        const result = this.api.advertisingPlatformServiceUploadOrderLineJob(body, _options);
        return result.toPromise();
    }

    /**
     * Upload OrderLine Job
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadOrderLineJob2(body: V1UploadOrderLineJobRequest, _options?: Configuration): Promise<V1OrderLineJob> {
        const result = this.api.advertisingPlatformServiceUploadOrderLineJob2(body, _options);
        return result.toPromise();
    }


}



import { ObservableCreativesApi } from './ObservableAPI';

import { CreativesApiRequestFactory, CreativesApiResponseProcessor} from "../apis/CreativesApi";
export class PromiseCreativesApi {
    private api: ObservableCreativesApi

    public constructor(
        configuration: Configuration,
        requestFactory?: CreativesApiRequestFactory,
        responseProcessor?: CreativesApiResponseProcessor
    ) {
        this.api = new ObservableCreativesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * ArchiveCreative
     * @param body 
     */
    public advertisingPlatformServiceArchiveCreative(body: V1ArchiveCreativeRequest, _options?: Configuration): Promise<Creativeservicev1Creative> {
        const result = this.api.advertisingPlatformServiceArchiveCreative(body, _options);
        return result.toPromise();
    }

    /**
     * Create Creative
     * @param orgId The Organization where this Creative will be created.
     * @param creative The creative to create.
     */
    public advertisingPlatformServiceCreateCreative(orgId: string, creative: Creativeservicev1Creative, _options?: Configuration): Promise<Creativeservicev1Creative> {
        const result = this.api.advertisingPlatformServiceCreateCreative(orgId, creative, _options);
        return result.toPromise();
    }

    /**
     * Delete Creative
     * @param creativeId The ID of the creative to delete.
     * @param orgId The Organization where this Creative belongs to.
     */
    public advertisingPlatformServiceDeleteCreative(creativeId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteCreative(creativeId, orgId, _options);
        return result.toPromise();
    }

    /**
     * DownloadCreativeFile
     * @param orgId ID of the org that the creative belongs to
     * @param creativeId The ID of the Creative.
     * @param fileId The ID of the Creative File.
     */
    public advertisingPlatformServiceDownloadCreativeFile(orgId: string, creativeId?: string, fileId?: string, _options?: Configuration): Promise<StreamResultOfV1DownloadCreativeFileResponse> {
        const result = this.api.advertisingPlatformServiceDownloadCreativeFile(orgId, creativeId, fileId, _options);
        return result.toPromise();
    }

    /**
     * Get Creative
     * @param creativeId The ID of the creative to retrieve.
     * @param orgId The Organization where this Creative belongs to.
     */
    public advertisingPlatformServiceGetCreative(creativeId: string, orgId: string, _options?: Configuration): Promise<Creativeservicev1Creative> {
        const result = this.api.advertisingPlatformServiceGetCreative(creativeId, orgId, _options);
        return result.toPromise();
    }

    /**
     * List Creative Folders
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCreativeFolders&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreativeFolders&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListCreativeFolders(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListCreativeFoldersResponse> {
        const result = this.api.advertisingPlatformServiceListCreativeFolders(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List Creatives
     * @param pageSize The maximum number of creatives to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; creatives will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListCreatives&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreatives&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param descendantOfOrgId If specified, only return creatives of the specified org_id and its descendants.
     */
    public advertisingPlatformServiceListCreatives(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, descendantOfOrgId?: string, _options?: Configuration): Promise<Creativeservicev1ListCreativesResponse> {
        const result = this.api.advertisingPlatformServiceListCreatives(pageSize, pageToken, orderBy, filter, descendantOfOrgId, _options);
        return result.toPromise();
    }

    /**
     * Start Archiving Creative
     */
    public advertisingPlatformServiceStartArchivingCreative(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceStartArchivingCreative(_options);
        return result.toPromise();
    }

    /**
     * Unarchive Creative
     * @param body 
     */
    public advertisingPlatformServiceUnarchiveCreative(body: V1UnarchiveCreativeRequest, _options?: Configuration): Promise<Creativeservicev1Creative> {
        const result = this.api.advertisingPlatformServiceUnarchiveCreative(body, _options);
        return result.toPromise();
    }

    /**
     * Update Creative
     * @param creativeId ID of the Creative
     * @param orgId The Organization where this Creative belongs to.
     * @param creative The creative to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateCreative(creativeId: string, orgId: string, creative: TheCreativeToUpdate, updateMask?: string, _options?: Configuration): Promise<Creativeservicev1Creative> {
        const result = this.api.advertisingPlatformServiceUpdateCreative(creativeId, orgId, creative, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Upload Creative File
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadCreativeFile(body: V1UploadCreativeFileRequest, _options?: Configuration): Promise<V1CreativeFile> {
        const result = this.api.advertisingPlatformServiceUploadCreativeFile(body, _options);
        return result.toPromise();
    }


}



import { ObservableDeployApi } from './ObservableAPI';

import { DeployApiRequestFactory, DeployApiResponseProcessor} from "../apis/DeployApi";
export class PromiseDeployApi {
    private api: ObservableDeployApi

    public constructor(
        configuration: Configuration,
        requestFactory?: DeployApiRequestFactory,
        responseProcessor?: DeployApiResponseProcessor
    ) {
        this.api = new ObservableDeployApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a advertiser in deploy
     * Create an Advertiser
     * @param advertiser the advertiser to create.
     */
    public advertisingPlatformServiceCreateDeployServiceAdvertiser(advertiser: V3Advertiser, _options?: Configuration): Promise<V3Advertiser> {
        const result = this.api.advertisingPlatformServiceCreateDeployServiceAdvertiser(advertiser, _options);
        return result.toPromise();
    }

    /**
     * Create a campaign in deploy
     * Create an Campaign
     * @param campaign the campaign to create.
     */
    public advertisingPlatformServiceCreateDeployServiceCampaign(campaign: Deployservicev3Campaign, _options?: Configuration): Promise<Deployservicev3Campaign> {
        const result = this.api.advertisingPlatformServiceCreateDeployServiceCampaign(campaign, _options);
        return result.toPromise();
    }

    /**
     * Create a creative in deploy
     * Create a Creative in deploy
     * @param creative the creative to create.
     */
    public advertisingPlatformServiceCreateDeployServiceCreative(creative: Deployservicev3Creative, _options?: Configuration): Promise<Deployservicev3Creative> {
        const result = this.api.advertisingPlatformServiceCreateDeployServiceCreative(creative, _options);
        return result.toPromise();
    }

    /**
     * Create a deployment in deploy
     * Create an Deployment
     * @param deployment the segment to create.
     */
    public advertisingPlatformServiceCreateDeployServiceDeployment(deployment: Deployservicev3Deployment, _options?: Configuration): Promise<Deployservicev3Deployment> {
        const result = this.api.advertisingPlatformServiceCreateDeployServiceDeployment(deployment, _options);
        return result.toPromise();
    }

    /**
     * Create a segment in deploy
     * Create an Segment
     * @param segment the segment to create.
     */
    public advertisingPlatformServiceCreateDeployServiceSegment(segment: V3Segment, _options?: Configuration): Promise<V3Segment> {
        const result = this.api.advertisingPlatformServiceCreateDeployServiceSegment(segment, _options);
        return result.toPromise();
    }

    /**
     * Delete a advertiser in deploy
     * Delete a Advertiser
     * @param advertiserId The ID of the Advertiser
     */
    public advertisingPlatformServiceDeleteDeployServiceAdvertiser(advertiserId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteDeployServiceAdvertiser(advertiserId, _options);
        return result.toPromise();
    }

    /**
     * Delete a campaign in deploy
     * Delete a Campaign
     * @param campaignId The ID of the Campaign
     */
    public advertisingPlatformServiceDeleteDeployServiceCampaign(campaignId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteDeployServiceCampaign(campaignId, _options);
        return result.toPromise();
    }

    /**
     * Delete a creative in deploy
     * Delete a Creative
     * @param creativeId The ID of the Creative
     */
    public advertisingPlatformServiceDeleteDeployServiceCreative(creativeId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteDeployServiceCreative(creativeId, _options);
        return result.toPromise();
    }

    /**
     * Delete a deployment in deploy
     * Delete a Deployment
     * @param deploymentId The ID of the Deployment
     */
    public advertisingPlatformServiceDeleteDeployServiceDeployment(deploymentId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteDeployServiceDeployment(deploymentId, _options);
        return result.toPromise();
    }

    /**
     * Delete a segment in deploy
     * Delete a Segment
     * @param segmentId The ID of the Segment
     */
    public advertisingPlatformServiceDeleteDeployServiceSegment(segmentId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteDeployServiceSegment(segmentId, _options);
        return result.toPromise();
    }

    /**
     * Hits the generic deploy
     * @param body 
     */
    public advertisingPlatformServiceDeploy(body: V3GenericDeployRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeploy(body, _options);
        return result.toPromise();
    }

    /**
     * Deploy segment(s) to xandr curate
     * Create deployment configs for and deploy segment(s) to xandr curate
     * @param body 
     */
    public advertisingPlatformServiceDeploySegmentsToCurate(body: V3DeploySegmentsToCurateRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeploySegmentsToCurate(body, _options);
        return result.toPromise();
    }

    /**
     * Get advertisers
     * Get a Advertiser
     * @param advertiserId The ID of the Advertiser
     */
    public advertisingPlatformServiceGetDeployServiceAdvertiser(advertiserId: string, _options?: Configuration): Promise<V3Advertiser> {
        const result = this.api.advertisingPlatformServiceGetDeployServiceAdvertiser(advertiserId, _options);
        return result.toPromise();
    }

    /**
     * Get campaigns
     * Get a Campaign
     * @param campaignId The ID of the Campaign
     */
    public advertisingPlatformServiceGetDeployServiceCampaign(campaignId: string, _options?: Configuration): Promise<Deployservicev3Campaign> {
        const result = this.api.advertisingPlatformServiceGetDeployServiceCampaign(campaignId, _options);
        return result.toPromise();
    }

    /**
     * Get creatives
     * Get a Creative
     * @param creativeId The ID of the Creative
     */
    public advertisingPlatformServiceGetDeployServiceCreative(creativeId: string, _options?: Configuration): Promise<Deployservicev3Creative> {
        const result = this.api.advertisingPlatformServiceGetDeployServiceCreative(creativeId, _options);
        return result.toPromise();
    }

    /**
     * Get deployments
     * Get a Deployment
     * @param deploymentId The ID of the Deployment
     */
    public advertisingPlatformServiceGetDeployServiceDeployment(deploymentId: string, _options?: Configuration): Promise<Deployservicev3Deployment> {
        const result = this.api.advertisingPlatformServiceGetDeployServiceDeployment(deploymentId, _options);
        return result.toPromise();
    }

    /**
     * Get segments
     * Get a Segment
     * @param segmentId The ID of the Segment
     */
    public advertisingPlatformServiceGetDeployServiceSegment(segmentId: string, _options?: Configuration): Promise<V3Segment> {
        const result = this.api.advertisingPlatformServiceGetDeployServiceSegment(segmentId, _options);
        return result.toPromise();
    }

    /**
     * List all advertisers
     * List Advertisers
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListAdvertisersRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListAdvertisersRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceAdvertisers(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V3ListAdvertisersResponse> {
        const result = this.api.advertisingPlatformServiceListDeployServiceAdvertisers(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List all campaigns
     * List Campaigns
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListCampaignsRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCampaignsRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceCampaigns(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<Deployservicev3ListCampaignsResponse> {
        const result = this.api.advertisingPlatformServiceListDeployServiceCampaigns(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List all creatives
     * List Creatives
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListCreativesRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreativesRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceCreatives(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<Deployservicev3ListCreativesResponse> {
        const result = this.api.advertisingPlatformServiceListDeployServiceCreatives(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List all deployments
     * List Deployments
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListDeploymentsRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListDeploymentsRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceDeployments(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V3ListDeploymentsResponse> {
        const result = this.api.advertisingPlatformServiceListDeployServiceDeployments(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List all segments
     * List Segments
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 50 resources will be returned. The maximum value is 1000; values above 1000 will be coerced to 1000.
     * @param pageToken A page token, received from a previous &#x60;ListSegmentsRequest&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListSegmentsRequest&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering. Only one column sorting is supported as of now.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListDeployServiceSegments(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V3ListSegmentsResponse> {
        const result = this.api.advertisingPlatformServiceListDeployServiceSegments(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Deploy objects to their destinations
     * Queue a request to deploy deploy objects to destinations
     * @param body 
     */
    public advertisingPlatformServiceQueueDeployServiceRequest(body: V3QueueRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceQueueDeployServiceRequest(body, _options);
        return result.toPromise();
    }

    /**
     * Update an advertiser in deploy
     * Update a Advertiser
     * @param advertiserId The ID of the advertiser.
     * @param advertiser the advertiser to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceAdvertiser(advertiserId: string, advertiser: TheAdvertiserToCreate, updateMask?: string, _options?: Configuration): Promise<V3Advertiser> {
        const result = this.api.advertisingPlatformServiceUpdateDeployServiceAdvertiser(advertiserId, advertiser, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update a Campaign in deploy
     * Update a Campaign
     * @param campaignId The ID of the campaign.
     * @param campaign the campaign to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceCampaign(campaignId: string, campaign: TheCampaignToCreate, updateMask?: string, _options?: Configuration): Promise<Deployservicev3Campaign> {
        const result = this.api.advertisingPlatformServiceUpdateDeployServiceCampaign(campaignId, campaign, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update a creative in deploy
     * Update a Creative
     * @param creativeId The ID of the creative object in the deploy service.
     * @param creative the creative to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceCreative(creativeId: string, creative: TheCreativeToCreate, updateMask?: string, _options?: Configuration): Promise<Deployservicev3Creative> {
        const result = this.api.advertisingPlatformServiceUpdateDeployServiceCreative(creativeId, creative, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update a deployment in deploy
     * Update a Deployment
     * @param deploymentId The ID for the deployment
     * @param deployment the deployment to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceDeployment(deploymentId: string, deployment: TheDeploymentToCreate, updateMask?: string, _options?: Configuration): Promise<Deployservicev3Deployment> {
        const result = this.api.advertisingPlatformServiceUpdateDeployServiceDeployment(deploymentId, deployment, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update a segment in deploy
     * Update a Segment
     * @param segmentId The ID of the segment.
     * @param segment the segment to create.
     * @param updateMask update_mask  The list of fields to update
     */
    public advertisingPlatformServiceUpdateDeployServiceSegment(segmentId: string, segment: TheSegmentToCreate, updateMask?: string, _options?: Configuration): Promise<V3Segment> {
        const result = this.api.advertisingPlatformServiceUpdateDeployServiceSegment(segmentId, segment, updateMask, _options);
        return result.toPromise();
    }


}



import { ObservableExportDataFromThePlatformToColdStorageApi } from './ObservableAPI';

import { ExportDataFromThePlatformToColdStorageApiRequestFactory, ExportDataFromThePlatformToColdStorageApiResponseProcessor} from "../apis/ExportDataFromThePlatformToColdStorageApi";
export class PromiseExportDataFromThePlatformToColdStorageApi {
    private api: ObservableExportDataFromThePlatformToColdStorageApi

    public constructor(
        configuration: Configuration,
        requestFactory?: ExportDataFromThePlatformToColdStorageApiRequestFactory,
        responseProcessor?: ExportDataFromThePlatformToColdStorageApiResponseProcessor
    ) {
        this.api = new ObservableExportDataFromThePlatformToColdStorageApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param body 
     */
    public advertisingPlatformServiceExportData(body: any, _options?: Configuration): Promise<V1ExportDataResponse> {
        const result = this.api.advertisingPlatformServiceExportData(body, _options);
        return result.toPromise();
    }


}



import { ObservableGlobalSearchApi } from './ObservableAPI';

import { GlobalSearchApiRequestFactory, GlobalSearchApiResponseProcessor} from "../apis/GlobalSearchApi";
export class PromiseGlobalSearchApi {
    private api: ObservableGlobalSearchApi

    public constructor(
        configuration: Configuration,
        requestFactory?: GlobalSearchApiRequestFactory,
        responseProcessor?: GlobalSearchApiResponseProcessor
    ) {
        this.api = new ObservableGlobalSearchApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Case insensitive and diacritic text searches. Matches on the complete stemmed word. So if a document field contains the word blueberry, a search on the term blue will not match. However, blueberry or blueberries will match.
     * GlobalSearch
     * @param orgIds List of Org IDs to Search
     * @param keywords List of keywords to search for. Only supports one at the moment.
     */
    public advertisingPlatformServiceGlobalSearch(orgIds?: Array<string>, keywords?: Array<string>, _options?: Configuration): Promise<V1GlobalSearchResponse> {
        const result = this.api.advertisingPlatformServiceGlobalSearch(orgIds, keywords, _options);
        return result.toPromise();
    }


}



import { ObservableHealthCheckApi } from './ObservableAPI';

import { HealthCheckApiRequestFactory, HealthCheckApiResponseProcessor} from "../apis/HealthCheckApi";
export class PromiseHealthCheckApi {
    private api: ObservableHealthCheckApi

    public constructor(
        configuration: Configuration,
        requestFactory?: HealthCheckApiRequestFactory,
        responseProcessor?: HealthCheckApiResponseProcessor
    ) {
        this.api = new ObservableHealthCheckApi(configuration, requestFactory, responseProcessor);
    }

    /**
     */
    public advertisingPlatformServiceGetAPQSHealthCheck(_options?: Configuration): Promise<Apqsv1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetAPQSHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetAudienceHealthCheck(_options?: Configuration): Promise<Targetjobservicev1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetAudienceHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetBillingHealthCheck(_options?: Configuration): Promise<Billingservicev1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetBillingHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetCampaignHealthCheck(_options?: Configuration): Promise<Campaignservicev1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetCampaignHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetCreativeHealthCheck(_options?: Configuration): Promise<Creativeservicev1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetCreativeHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetDeployHealthCheck(_options?: Configuration): Promise<Deployservicev3HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetDeployHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetHealthCheck(_options?: Configuration): Promise<Hagridv1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetNotificationHealthCheck(_options?: Configuration): Promise<Notificationservicev1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetNotificationHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetOrgHealthCheck(_options?: Configuration): Promise<Orgmanagerv1HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetOrgHealthCheck(_options);
        return result.toPromise();
    }

    /**
     */
    public advertisingPlatformServiceGetTargetHealthCheck(_options?: Configuration): Promise<Targetorchestratorv2HealthCheck> {
        const result = this.api.advertisingPlatformServiceGetTargetHealthCheck(_options);
        return result.toPromise();
    }


}



import { ObservableJobsApi } from './ObservableAPI';

import { JobsApiRequestFactory, JobsApiResponseProcessor} from "../apis/JobsApi";
export class PromiseJobsApi {
    private api: ObservableJobsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: JobsApiRequestFactory,
        responseProcessor?: JobsApiResponseProcessor
    ) {
        this.api = new ObservableJobsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create Job
     * @param orgId The Organization where this job will be created.
     * @param job The job to create.
     */
    public advertisingPlatformServiceCreateJob(orgId: string, job: V1Job, _options?: Configuration): Promise<V1Job> {
        const result = this.api.advertisingPlatformServiceCreateJob(orgId, job, _options);
        return result.toPromise();
    }

    /**
     * Delete Job
     * @param jobId The ID of the job to delete.
     * @param orgId The Organization where this Job belongs to.
     */
    public advertisingPlatformServiceDeleteJob(jobId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteJob(jobId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Download Job File
     * @param jobId The ID of the job.
     * @param jobFileType File type to download.   - JOB_FILE_TYPE_UNKNOWN: Unknown File Type.  - JOB_FILE_TYPE_ANNOTATED: File of the original source file data with a boolean that specifies whether the row was matched or not.  - JOB_FILE_TYPE_SELECTED: File of the ip addresses and ethashs.  - JOB_FILE_TYPE_VALIDATED: File of the validated addresses.  - JOB_FILE_TYPE_RESULTS: File of the results of digital canvas.  - JOB_FILE_TYPE_DIRECT_MAIL: File of direct mail addresses.  - JOB_FILE_TYPE_HOMES: File of the addresses of devices found in venue replay.  - JOB_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN: File of the devices found in homes but not found with venue replay.  - JOB_FILE_TYPE_DEVICES_WITH_HOMES: File of the devices with homes found in venue replay.  - JOB_FILE_TYPE_DEVICES_WITHOUT_HOMES: File of the devices without homes found in venue replay.  - JOB_FILE_TYPE_MAIDS: File of MAIDS addresses.  - JOB_FILE_TYPE_ENRICHED: File of Enriched addresses.  - JOB_FILE_TYPE_SALES_MATCHBACK: CSV that joins the ethashed sales file to the compiled audience file on the ethash column.  - JOB_FILE_TYPE_ORDER_LINE_MATCHBACK: JSON file that encompasses the orderline and audience relations for the matchbacking job.  - JOB_FILE_TYPE_ETHASHED_SALES: CSV file that contains the original sales file with the ethash and the match code for each row.  - JOB_FILE_TYPE_COMPILED_AUDIENCE: CSV file that contains the following columns generated by an ethash job: AudienceID, OLID, CurrentlyAttached, Deployed, Served, Excluded, ETHash, Matched, Address, Zip, ServeTimeFrames
     * @param orgId The ID of the target&#39;s org
     */
    public advertisingPlatformServiceDownloadJobFile(jobId?: string, jobFileType?: 'JOB_FILE_TYPE_UNKNOWN' | 'JOB_FILE_TYPE_ANNOTATED' | 'JOB_FILE_TYPE_SELECTED' | 'JOB_FILE_TYPE_VALIDATED' | 'JOB_FILE_TYPE_RESULTS' | 'JOB_FILE_TYPE_DIRECT_MAIL' | 'JOB_FILE_TYPE_HOMES' | 'JOB_FILE_TYPE_DEVICES_IN_HOMES_NOT_SEEN' | 'JOB_FILE_TYPE_DEVICES_WITH_HOMES' | 'JOB_FILE_TYPE_DEVICES_WITHOUT_HOMES' | 'JOB_FILE_TYPE_MAIDS' | 'JOB_FILE_TYPE_ENRICHED' | 'JOB_FILE_TYPE_SALES_MATCHBACK' | 'JOB_FILE_TYPE_ORDER_LINE_MATCHBACK' | 'JOB_FILE_TYPE_ETHASHED_SALES' | 'JOB_FILE_TYPE_COMPILED_AUDIENCE', orgId?: string, _options?: Configuration): Promise<StreamResultOfV1DownloadJobFileResponse> {
        const result = this.api.advertisingPlatformServiceDownloadJobFile(jobId, jobFileType, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get Job
     * @param jobId The ID of the job to retrieve.
     * @param orgId The Organization where this Job belongs to.
     */
    public advertisingPlatformServiceGetJob(jobId: string, orgId: string, _options?: Configuration): Promise<V1Job> {
        const result = this.api.advertisingPlatformServiceGetJob(jobId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Run Job
     * @param jobId The ID of the Job.
     * @param orgId The ID of the Org associated to the Job.
     * @param version (OPTIONAL) The version of the target file to use. If empty, the most recent version is used.
     * @param queryId (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param seenCount (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param locType (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
     * @param radius (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryType (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
     * @param queryArgs (OPTIONAL) Additional field you might need in order to run a job.
     */
    public advertisingPlatformServiceRunJob(jobId?: string, orgId?: string, version?: number, queryId?: string, seenCount?: number, locType?: string, radius?: number, queryType?: string, queryArgs?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceRunJob(jobId, orgId, version, queryId, seenCount, locType, radius, queryType, queryArgs, _options);
        return result.toPromise();
    }

    /**
     * Update Job
     * @param jobId The Job ID.
     * @param job Job  Job holds info about a specific Job.
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateJob(jobId: string, job: Job, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1Job> {
        const result = this.api.advertisingPlatformServiceUpdateJob(jobId, job, updateMask, orgId, _options);
        return result.toPromise();
    }


}



import { ObservableNewMoverApi } from './ObservableAPI';

import { NewMoverApiRequestFactory, NewMoverApiResponseProcessor} from "../apis/NewMoverApi";
export class PromiseNewMoverApi {
    private api: ObservableNewMoverApi

    public constructor(
        configuration: Configuration,
        requestFactory?: NewMoverApiRequestFactory,
        responseProcessor?: NewMoverApiResponseProcessor
    ) {
        this.api = new ObservableNewMoverApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Get the number of matched new mover homes for specified mover type(s) for a specified state or zipcode(s)
     * Get New Mover Match Count
     * @param moverType Mover Type  The type of mover for which you want to get the count.
     * @param stateAbbreviation State Abbreviation  The abbreviation of the state from which you want to get the mover count. You can query by state abbreviation or zipcode(s) but not both.
     * @param zipcode Zipcodes  The zipcodes from which you want to get the mover count. You can query by state abbreviation or zipcode(s) but not both.
     * @param orgId Org id  The org_id associated with the user making the request
     * @param requestId Request_ID  Id of the request
     */
    public advertisingPlatformServiceGetNewMoverMatchCount(moverType?: Array<string>, stateAbbreviation?: string, zipcode?: Array<string>, orgId?: string, requestId?: string, _options?: Configuration): Promise<V1GetNewMoverMatchCountResponse> {
        const result = this.api.advertisingPlatformServiceGetNewMoverMatchCount(moverType, stateAbbreviation, zipcode, orgId, requestId, _options);
        return result.toPromise();
    }


}



import { ObservableNotificationsApi } from './ObservableAPI';

import { NotificationsApiRequestFactory, NotificationsApiResponseProcessor} from "../apis/NotificationsApi";
export class PromiseNotificationsApi {
    private api: ObservableNotificationsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: NotificationsApiRequestFactory,
        responseProcessor?: NotificationsApiResponseProcessor
    ) {
        this.api = new ObservableNotificationsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Gets all notifications irrespective of activity or global/user-specific
     * @param pageSize The maximum number of notifications to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; organizations will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;AdminListNotifications&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;AdminListNotifications&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceAdminListNotifications(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1AdminListNotificationsResponse> {
        const result = this.api.advertisingPlatformServiceAdminListNotifications(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Create an Email Mapping
     * @param body 
     */
    public advertisingPlatformServiceCreateEmailMapping(body: V1CreateEmailMappingRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceCreateEmailMapping(body, _options);
        return result.toPromise();
    }

    /**
     * creates a notification to be sent when specific events occur.
     * creates a notification to be sent when specific events occur
     * @param notification 
     */
    public advertisingPlatformServiceCreateNotification(notification: V1Notification, _options?: Configuration): Promise<V1Notification> {
        const result = this.api.advertisingPlatformServiceCreateNotification(notification, _options);
        return result.toPromise();
    }

    /**
     * Create an Email Route
     * Notification Service Routes -> *All Internally Managed*
     * @param body 
     */
    public advertisingPlatformServiceCreateRoute(body: V1CreateRouteRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceCreateRoute(body, _options);
        return result.toPromise();
    }

    /**
     * Delete an Email Mapping
     * @param name 
     */
    public advertisingPlatformServiceDeleteEmailMapping(name: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteEmailMapping(name, _options);
        return result.toPromise();
    }

    /**
     * delete a notification
     * delete a notification
     * @param notificationId 
     */
    public advertisingPlatformServiceDeleteNotification(notificationId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteNotification(notificationId, _options);
        return result.toPromise();
    }

    /**
     * Delete an Email Route
     * @param routeIdentifier 
     */
    public advertisingPlatformServiceDeleteRoute(routeIdentifier: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteRoute(routeIdentifier, _options);
        return result.toPromise();
    }

    /**
     * Create an Email Mapping
     * @param name 
     */
    public advertisingPlatformServiceGetEmailMapping(name: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceGetEmailMapping(name, _options);
        return result.toPromise();
    }

    /**
     * Get notification by its id.
     * Get notification by ID
     * @param notificationId 
     */
    public advertisingPlatformServiceGetNotification(notificationId: string, _options?: Configuration): Promise<V1Notification> {
        const result = this.api.advertisingPlatformServiceGetNotification(notificationId, _options);
        return result.toPromise();
    }

    /**
     * Get global notifications and a user's notifications provided a user_id is supplied.
     * Get global + user notifications
     * @param userId 
     */
    public advertisingPlatformServiceGetNotifications(userId?: string, _options?: Configuration): Promise<V1GetNotificationsResponse> {
        const result = this.api.advertisingPlatformServiceGetNotifications(userId, _options);
        return result.toPromise();
    }

    /**
     * Create an Email Route
     * @param routeIdentifier 
     */
    public advertisingPlatformServiceGetRoute(routeIdentifier: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceGetRoute(routeIdentifier, _options);
        return result.toPromise();
    }

    /**
     * Get the job report for a specific route
     * @param jobId The ID of the River Job you want to fetch
     */
    public advertisingPlatformServiceGetRouteJobReport(jobId: number, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceGetRouteJobReport(jobId, _options);
        return result.toPromise();
    }

    /**
     * Get all Email Mappings
     */
    public advertisingPlatformServiceListEmailMappings(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceListEmailMappings(_options);
        return result.toPromise();
    }

    /**
     * Get all Email Routes
     */
    public advertisingPlatformServiceListRoutes(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceListRoutes(_options);
        return result.toPromise();
    }

    /**
     * Request an org name change
     * @param body 
     */
    public advertisingPlatformServiceRequestOrgNameChange(body: V1RequestOrgNameChangeRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceRequestOrgNameChange(body, _options);
        return result.toPromise();
    }

    /**
     * Request support from AdOps
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceRequestSupport(body: V1RequestSupportRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceRequestSupport(body, _options);
        return result.toPromise();
    }

    /**
     * send a message
     * @param body 
     */
    public advertisingPlatformServiceSendMessage(body: V1SendMessageRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceSendMessage(body, _options);
        return result.toPromise();
    }

    /**
     * Send OrderLine Ending Message for all order lines ending in 7 days
     */
    public advertisingPlatformServiceSendOrderLineEndingNotifications(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceSendOrderLineEndingNotifications(_options);
        return result.toPromise();
    }

    /**
     * Send a message to orgs that have order lines that are ready but not submitted
     */
    public advertisingPlatformServiceSendOrderLineReadyButNotSubmittedNotifications(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceSendOrderLineReadyButNotSubmittedNotifications(_options);
        return result.toPromise();
    }

    /**
     * Trigger an email route to send emails based on its template configs
     * @param routeIdentifier The identifier/name of the email route to trigger
     * @param body 
     */
    public advertisingPlatformServiceTriggerRoute(routeIdentifier: string, body: AdvertisingPlatformServiceTriggerRouteRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceTriggerRoute(routeIdentifier, body, _options);
        return result.toPromise();
    }

    /**
     * Update an Email Mapping
     * @param name 
     * @param body 
     */
    public advertisingPlatformServiceUpdateEmailMapping(name: string, body: AdvertisingPlatformServiceUpdateEmailMappingRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceUpdateEmailMapping(name, body, _options);
        return result.toPromise();
    }

    /**
     * update any notification fields except send_to and groups.
     * update any notification fields except send_to and groups
     * @param notificationId 
     * @param notification Notification  Contains data after creating a notification
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateNotification(notificationId: string, notification: Notification, updateMask?: string, _options?: Configuration): Promise<V1Notification> {
        const result = this.api.advertisingPlatformServiceUpdateNotification(notificationId, notification, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update an Email Route
     * @param routeIdentifier 
     * @param body 
     */
    public advertisingPlatformServiceUpdateRoute(routeIdentifier: string, body: AdvertisingPlatformServiceUpdateRouteRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceUpdateRoute(routeIdentifier, body, _options);
        return result.toPromise();
    }


}



import { ObservableOrganizationsApi } from './ObservableAPI';

import { OrganizationsApiRequestFactory, OrganizationsApiResponseProcessor} from "../apis/OrganizationsApi";
export class PromiseOrganizationsApi {
    private api: ObservableOrganizationsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: OrganizationsApiRequestFactory,
        responseProcessor?: OrganizationsApiResponseProcessor
    ) {
        this.api = new ObservableOrganizationsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param orgId 
     * @param noteId 
     */
    public advertisingPlatformServiceActivateOrgNote(orgId: string, noteId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceActivateOrgNote(orgId, noteId, _options);
        return result.toPromise();
    }

    /**
     * Add AccountRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddAccountRep(orgId: string, body: AdvertisingPlatformServiceAddAccountRepRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceAddAccountRep(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Add CommissionGroup
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddCommissionGroup(orgId: string, body: AdvertisingPlatformServiceAddCommissionGroupRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceAddCommissionGroup(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Add SalesRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddSalesRep(orgId: string, body: AdvertisingPlatformServiceAddSalesRepRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceAddSalesRep(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Add User
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceAddUser(orgId: string, body: AdvertisingPlatformServiceAddUserRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceAddUser(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Create CPM
     * @param orgId 
     * @param cpm 
     */
    public advertisingPlatformServiceCreateCPM(orgId: string, cpm: V1CPM, _options?: Configuration): Promise<V1CPM> {
        const result = this.api.advertisingPlatformServiceCreateCPM(orgId, cpm, _options);
        return result.toPromise();
    }

    /**
     * Create Contact
     * @param orgId 
     * @param contact 
     */
    public advertisingPlatformServiceCreateContact(orgId: string, contact: Orgmanagerv1Contact, _options?: Configuration): Promise<Orgmanagerv1Contact> {
        const result = this.api.advertisingPlatformServiceCreateContact(orgId, contact, _options);
        return result.toPromise();
    }

    /**
     * Create Organization
     * @param org The Organization to create.
     */
    public advertisingPlatformServiceCreateOrg(org: Orgmanagerv1Org, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceCreateOrg(org, _options);
        return result.toPromise();
    }

    /**
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceCreateOrgNote(orgId: string, body: AdvertisingPlatformServiceCreateOrgNoteRequest, _options?: Configuration): Promise<Orgmanagerv1Note> {
        const result = this.api.advertisingPlatformServiceCreateOrgNote(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * @param orgId 
     * @param noteId 
     */
    public advertisingPlatformServiceDeactivateOrgNote(orgId: string, noteId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeactivateOrgNote(orgId, noteId, _options);
        return result.toPromise();
    }

    /**
     * Ensures User's data synchronization between Keycloak, Debezium and OrgManager.
     * Debezium Sync Check
     * @param userId The ID of the User to retrieve.
     * @param body 
     */
    public advertisingPlatformServiceDebeziumSyncCheck(userId: string, body: any, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDebeziumSyncCheck(userId, body, _options);
        return result.toPromise();
    }

    /**
     * Delete CPM
     * @param orgId 
     * @param cpmId 
     */
    public advertisingPlatformServiceDeleteCPM(orgId: string, cpmId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteCPM(orgId, cpmId, _options);
        return result.toPromise();
    }

    /**
     * Delete Contact
     * @param orgId 
     * @param contactId 
     */
    public advertisingPlatformServiceDeleteContact(orgId: string, contactId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteContact(orgId, contactId, _options);
        return result.toPromise();
    }

    /**
     * Delete Organization
     * @param orgId The ID of the Organization to delete.
     */
    public advertisingPlatformServiceDeleteOrg(orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteOrg(orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete Org Logo
     * @param orgId ID of the org whose logo will be deleted
     */
    public advertisingPlatformServiceDeleteOrgLogo(orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteOrgLogo(orgId, _options);
        return result.toPromise();
    }

    /**
     * Get and Org from an Org ID
     * Get Organization
     * @param orgId The ID of the Organization to retrieve.
     * @param skipPreload 
     */
    public advertisingPlatformServiceGetOrg(orgId: string, skipPreload?: boolean, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceGetOrg(orgId, skipPreload, _options);
        return result.toPromise();
    }

    /**
     * List org users
     * @param orgId 
     * @param pageSize 
     * @param pageToken 
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListOrgUsers(orgId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListOrgUsersResponse> {
        const result = this.api.advertisingPlatformServiceListOrgUsers(orgId, pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List Organizations
     * @param pageSize The maximum number of organizations to return. The service may return fewer than this value.  If unspecified, at most &#x60;100&#x60; organizations will be returned.  The maximum value is &#x60;100&#x60;; values above &#x60;100&#x60; will be coerced to &#x60;100&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListOrgs&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrgs&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param skipPreload If true, then nested fields won&#39;t be populated. Use this for a faster response time.
     * @param userId Filter the Orgs returned by User ID.
     */
    public advertisingPlatformServiceListOrgs(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, skipPreload?: boolean, userId?: string, _options?: Configuration): Promise<V1ListOrgsResponse> {
        const result = this.api.advertisingPlatformServiceListOrgs(pageSize, pageToken, orderBy, filter, skipPreload, userId, _options);
        return result.toPromise();
    }

    /**
     * Update an org's parent org id
     * Move Organization
     * @param id The id of the org to move
     * @param body 
     */
    public advertisingPlatformServiceMoveOrg(id: string, body: MoveOrgsRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceMoveOrg(id, body, _options);
        return result.toPromise();
    }

    /**
     * Remove AccountRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveAccountRep(orgId: string, body: AdvertisingPlatformServiceAddAccountRepRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceRemoveAccountRep(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Remove CommissionGroup
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveCommissionGroup(orgId: string, body: AdvertisingPlatformServiceRemoveCommissionGroupRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceRemoveCommissionGroup(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Remove SalesRep
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveSalesRep(orgId: string, body: AdvertisingPlatformServiceAddSalesRepRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceRemoveSalesRep(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Remove User
     * @param orgId 
     * @param body 
     */
    public advertisingPlatformServiceRemoveUser(orgId: string, body: AdvertisingPlatformServiceRemoveUserRequest, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceRemoveUser(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Update CPM
     * @param orgId 
     * @param cpmId ID of the CPM
     * @param cpm CPM contains information relating to a client cpmanization
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateCPM(orgId: string, cpmId: string, cpm: CPMContainsInformationRelatingToAClientCpmanization, updateMask?: string, _options?: Configuration): Promise<V1CPM> {
        const result = this.api.advertisingPlatformServiceUpdateCPM(orgId, cpmId, cpm, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update Contact
     * @param orgId 
     * @param contactId ID of the Contact
     * @param contact Contact  Contacts store information of people interested in an org
     * @param updateMask 
     */
    public advertisingPlatformServiceUpdateContact(orgId: string, contactId: string, contact: Contact, updateMask?: string, _options?: Configuration): Promise<Orgmanagerv1Contact> {
        const result = this.api.advertisingPlatformServiceUpdateContact(orgId, contactId, contact, updateMask, _options);
        return result.toPromise();
    }

    /**
     * Update Organization
     * @param orgId ID of the Organization
     * @param org The Organization to update.
     * @param updateMask The list of fields to update.
     */
    public advertisingPlatformServiceUpdateOrg(orgId: string, org: TheOrganizationToUpdate, updateMask?: string, _options?: Configuration): Promise<Orgmanagerv1Org> {
        const result = this.api.advertisingPlatformServiceUpdateOrg(orgId, org, updateMask, _options);
        return result.toPromise();
    }


}



import { ObservableOrgsApi } from './ObservableAPI';

import { OrgsApiRequestFactory, OrgsApiResponseProcessor} from "../apis/OrgsApi";
export class PromiseOrgsApi {
    private api: ObservableOrgsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: OrgsApiRequestFactory,
        responseProcessor?: OrgsApiResponseProcessor
    ) {
        this.api = new ObservableOrgsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Batch Update Orgs
     * @param body 
     */
    public advertisingPlatformServiceBatchUpdateOrgs(body: V1BatchUpdateOrgsRequest, _options?: Configuration): Promise<V1BatchUpdateOrgsResponse> {
        const result = this.api.advertisingPlatformServiceBatchUpdateOrgs(body, _options);
        return result.toPromise();
    }


}



import { ObservablePolicyApi } from './ObservableAPI';

import { PolicyApiRequestFactory, PolicyApiResponseProcessor} from "../apis/PolicyApi";
export class PromisePolicyApi {
    private api: ObservablePolicyApi

    public constructor(
        configuration: Configuration,
        requestFactory?: PolicyApiRequestFactory,
        responseProcessor?: PolicyApiResponseProcessor
    ) {
        this.api = new ObservablePolicyApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Bundle a Policy
     * @param body 
     */
    public advertisingPlatformServiceBundle(body: V1BundleRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceBundle(body, _options);
        return result.toPromise();
    }

    /**
     * Download a Policy
     * @param policyPath Policy Path  The path to the policy you would like to download.
     */
    public advertisingPlatformServiceDownloadBundle(policyPath?: string, _options?: Configuration): Promise<StreamResultOfV1DownloadBundleResponse> {
        const result = this.api.advertisingPlatformServiceDownloadBundle(policyPath, _options);
        return result.toPromise();
    }


}



import { ObservableReportRunsApi } from './ObservableAPI';

import { ReportRunsApiRequestFactory, ReportRunsApiResponseProcessor} from "../apis/ReportRunsApi";
export class PromiseReportRunsApi {
    private api: ObservableReportRunsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: ReportRunsApiRequestFactory,
        responseProcessor?: ReportRunsApiResponseProcessor
    ) {
        this.api = new ObservableReportRunsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Deletes a run.
     * Delete Report Run
     * @param reportId Parent report.
     * @param runId Run to delete.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceDeleteReportRun(reportId: string, runId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteReportRun(reportId, runId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Retrieves a single run by ID.
     * Get Report Run
     * @param reportId Parent report.
     * @param runId Run to retrieve.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceGetReportRun(reportId: string, runId: string, orgId: string, _options?: Configuration): Promise<V1ReportRun> {
        const result = this.api.advertisingPlatformServiceGetReportRun(reportId, runId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Lists runs for a report.
     * List Report Runs
     * @param reportId Parent report.
     * @param pageSize Page Size  Maximum number of runs to return.
     * @param pageToken Page Token  Token from a previous ListReportRuns response. When paginating, all other parameters must match the call that produced the token.
     * @param orderBy Order By  Sort order.
     * @param filter Filter  Filter expression.
     */
    public advertisingPlatformServiceListReportRuns(reportId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListReportRunsResponse> {
        const result = this.api.advertisingPlatformServiceListReportRuns(reportId, pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Retries the same report run that failed and moves it from the FAILED to the SCHEDULED status.
     * Retry Report Run
     * @param reportId Parent report.
     * @param runId Run to retry. Must be in FAILED status.
     * @param body 
     */
    public advertisingPlatformServiceRetryReportRun(reportId: string, runId: string, body: AdvertisingPlatformServiceRetryReportRunRequest, _options?: Configuration): Promise<V1ReportRun> {
        const result = this.api.advertisingPlatformServiceRetryReportRun(reportId, runId, body, _options);
        return result.toPromise();
    }

    /**
     * Triggers a new manual run of an existing report. The new run starts in SCHEDULED status and executes asynchronously.
     * Run Report
     * @param reportId Report to run.
     * @param body 
     */
    public advertisingPlatformServiceRunReport(reportId: string, body: AdvertisingPlatformServiceRunReportRequest, _options?: Configuration): Promise<V1ReportRun> {
        const result = this.api.advertisingPlatformServiceRunReport(reportId, body, _options);
        return result.toPromise();
    }


}



import { ObservableReportsApi } from './ObservableAPI';

import { ReportsApiRequestFactory, ReportsApiResponseProcessor} from "../apis/ReportsApi";
export class PromiseReportsApi {
    private api: ObservableReportsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: ReportsApiRequestFactory,
        responseProcessor?: ReportsApiResponseProcessor
    ) {
        this.api = new ObservableReportsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Creates a report and returns the new ids. When should_run_now is true, the first run is also scheduled to start immediately. Any schedules supplied in the request are created together with the report.
     * Create Report
     * @param orgId Org ID  Owning organization.
     * @param report The report to create.
     * @param shouldRunNow Should Run Now  When true, the first run is also scheduled to start immediately. The response includes run_id.
     */
    public advertisingPlatformServiceCreateReport(orgId: string, report: V1Report, shouldRunNow?: boolean, _options?: Configuration): Promise<V1CreateReportResponse> {
        const result = this.api.advertisingPlatformServiceCreateReport(orgId, report, shouldRunNow, _options);
        return result.toPromise();
    }

    /**
     * Deletes a report and its associated schedules and runs.
     * Delete Report
     * @param reportId Report to delete.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceDeleteReport(reportId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteReport(reportId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Retrieves a single report by ID. Returns NotFound if the report has been deleted.
     * Get Report
     * @param reportId Report to retrieve.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceGetReport(reportId: string, orgId: string, _options?: Configuration): Promise<V1Report> {
        const result = this.api.advertisingPlatformServiceGetReport(reportId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Lists reports the caller has access to. Deleted reports are excluded. Use the filter parameter to narrow to a specific org.
     * List Reports
     * @param pageSize Page Size  Maximum number of reports to return.
     * @param pageToken Page Token  Token from a previous ListReports response. When paginating, all other parameters must match the call that produced the token.
     * @param orderBy Order By  Sort order.
     * @param filter Filter  Filter expression.
     */
    public advertisingPlatformServiceListReports(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListReportsResponse> {
        const result = this.api.advertisingPlatformServiceListReports(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Partially updates a report. Only fields listed in update_mask are modified. Schedules are not modifiable here; use Schedule sub-resource RPCs.
     * Update Report
     * @param reportId Server-assigned report identifier.
     * @param orgId Org ID  Owning organization.
     * @param report The report to update. Must include id (identifies which report) and the new values for every field listed in update_mask.
     * @param updateMask Update Mask  Field paths to update on the report. Paths referencing schedules, id, org_id, create_time, update_time, or delete_time are rejected.
     */
    public advertisingPlatformServiceUpdateReport(reportId: string, orgId: string, report: TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask, updateMask?: string, _options?: Configuration): Promise<V1Report> {
        const result = this.api.advertisingPlatformServiceUpdateReport(reportId, orgId, report, updateMask, _options);
        return result.toPromise();
    }


}



import { ObservableSchedulesApi } from './ObservableAPI';

import { SchedulesApiRequestFactory, SchedulesApiResponseProcessor} from "../apis/SchedulesApi";
export class PromiseSchedulesApi {
    private api: ObservableSchedulesApi

    public constructor(
        configuration: Configuration,
        requestFactory?: SchedulesApiRequestFactory,
        responseProcessor?: SchedulesApiResponseProcessor
    ) {
        this.api = new ObservableSchedulesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Creates a new schedule attached to an existing report.
     * Create Schedule
     * @param reportId Parent report.
     * @param orgId Org ID  Owning organization.
     * @param schedule The schedule to create.
     */
    public advertisingPlatformServiceCreateSchedule(reportId: string, orgId: string, schedule: V1Schedule, _options?: Configuration): Promise<V1Schedule> {
        const result = this.api.advertisingPlatformServiceCreateSchedule(reportId, orgId, schedule, _options);
        return result.toPromise();
    }

    /**
     * Deletes a schedule and cancels any future executions and it deletes all report runs associated with the schedule.
     * Delete Schedule
     * @param reportId Parent report.
     * @param scheduleId Schedule to delete.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceDeleteSchedule(reportId: string, scheduleId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteSchedule(reportId, scheduleId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Retrieves a single schedule by ID.
     * Get Schedule
     * @param reportId Parent report.
     * @param scheduleId Schedule to retrieve.
     * @param orgId Org ID  Owning organization.
     */
    public advertisingPlatformServiceGetSchedule(reportId: string, scheduleId: string, orgId: string, _options?: Configuration): Promise<V1Schedule> {
        const result = this.api.advertisingPlatformServiceGetSchedule(reportId, scheduleId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Lists schedules attached to a report.
     * List Schedules
     * @param reportId Parent report.
     * @param pageSize Page Size  Maximum number of schedules to return.
     * @param pageToken Page Token  Token from a previous ListSchedules response. When paginating, all other parameters must match the call that produced the token.
     * @param orderBy Order By  Sort order.
     * @param filter Filter  Filter expression.
     */
    public advertisingPlatformServiceListSchedules(reportId: string, pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V1ListSchedulesResponse> {
        const result = this.api.advertisingPlatformServiceListSchedules(reportId, pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Transitions schedules on a report from ACTIVE to INACTIVE. Omit schedule_ids to pause every ACTIVE schedule on the report. When schedule_ids is provided, the call is all-or-nothing: if any listed id is not ACTIVE, no schedules are paused and FailedPrecondition is returned.
     * Pause Schedules
     * @param reportId Parent report.
     * @param body 
     */
    public advertisingPlatformServicePauseSchedules(reportId: string, body: AdvertisingPlatformServicePauseSchedulesRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServicePauseSchedules(reportId, body, _options);
        return result.toPromise();
    }

    /**
     * Transitions schedules on a report from INACTIVE to ACTIVE. Omit schedule_ids to resume every INACTIVE schedule on the report. When schedule_ids is provided, the call is all-or-nothing: if any listed id is not INACTIVE, no schedules are resumed and FailedPrecondition is returned.
     * Play Schedules
     * @param reportId Parent report.
     * @param body 
     */
    public advertisingPlatformServicePlaySchedules(reportId: string, body: AdvertisingPlatformServicePlaySchedulesRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServicePlaySchedules(reportId, body, _options);
        return result.toPromise();
    }

    /**
     * Partially updates a schedule. Status, ownership, and timestamps are not modifiable. New start/end values must be today or future.
     * Update Schedule
     * @param reportId Parent report.
     * @param scheduleId Server-assigned schedule identifier.
     * @param orgId Org ID  Owning organization.
     * @param schedule The schedule to update. Must include id (identifies which schedule) and the new values for every field listed in update_mask.
     * @param updateMask Update Mask  Field paths to update on the schedule. Paths referencing status, id, org_id, report_id, create_time, update_time, or delete_time are rejected.
     */
    public advertisingPlatformServiceUpdateSchedule(reportId: string, scheduleId: string, orgId: string, schedule: TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask, updateMask?: string, _options?: Configuration): Promise<V1Schedule> {
        const result = this.api.advertisingPlatformServiceUpdateSchedule(reportId, scheduleId, orgId, schedule, updateMask, _options);
        return result.toPromise();
    }


}



import { ObservableStatsApi } from './ObservableAPI';

import { StatsApiRequestFactory, StatsApiResponseProcessor} from "../apis/StatsApi";
export class PromiseStatsApi {
    private api: ObservableStatsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: StatsApiRequestFactory,
        responseProcessor?: StatsApiResponseProcessor
    ) {
        this.api = new ObservableStatsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Get device type serve statistics on campaigns
     * Get Device Type Stat Results
     * @param orgId Filter results to specific organizations by providing one organization ID
     * @param body 
     */
    public advertisingPlatformServiceGetDeviceStats(orgId: string, body: DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries, _options?: Configuration): Promise<V1DeviceStatsResponse> {
        const result = this.api.advertisingPlatformServiceGetDeviceStats(orgId, body, _options);
        return result.toPromise();
    }

    /**
     * Get granular serve statistics on campaigns
     * Get Stat Results
     * @param orgId Filter results to specific organizations by providing one organization ID
     * @param body 
     */
    public advertisingPlatformServiceGetStats(orgId: string, body: StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries, _options?: Configuration): Promise<V1StatsResponse> {
        const result = this.api.advertisingPlatformServiceGetStats(orgId, body, _options);
        return result.toPromise();
    }


}



import { ObservableTargetsApi } from './ObservableAPI';

import { TargetsApiRequestFactory, TargetsApiResponseProcessor} from "../apis/TargetsApi";
export class PromiseTargetsApi {
    private api: ObservableTargetsApi

    public constructor(
        configuration: Configuration,
        requestFactory?: TargetsApiRequestFactory,
        responseProcessor?: TargetsApiResponseProcessor
    ) {
        this.api = new ObservableTargetsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Archive Target
     * @param body 
     */
    public advertisingPlatformServiceArchiveTarget(body: V2ArchiveTargetRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceArchiveTarget(body, _options);
        return result.toPromise();
    }

    /**
     * Create Json Target
     * @param body 
     */
    public advertisingPlatformServiceCreateJsonTarget(body: V2CreateJsonTargetRequest, _options?: Configuration): Promise<V2Target> {
        const result = this.api.advertisingPlatformServiceCreateJsonTarget(body, _options);
        return result.toPromise();
    }

    /**
     * Delete Target
     * @param targetId The ID of the Target.
     * @param orgId Org_id  The ID of the Org associated to the Job.
     */
    public advertisingPlatformServiceDeleteTarget(targetId: string, orgId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteTarget(targetId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Download Target File
     * @param targetId The ID of the Target.
     * @param targetFileType File type to download.   - FILE_TYPE_UNKNOWN: Unknown File Type.  - FILE_TYPE_ADDRESS: File of addresses.  - FILE_TYPE_IP: File of IPs.  - FILE_TYPE_ZIP: File of zip codes.  - FILE_TYPE_DEVICE: File of device IDs.  - FILE_TYPE_GEOJSON: File of GeoJSON polygons  - FILE_TYPE_WKB: File of WKBs  - FILE_TYPE_FILELESS: Target doesnt require a file  - FILE_TYPE_SOURCE: File of the original source file. Period.  - FILE_TYPE_CLEANED: File of the original source file that has been processed by the filecleaner lambda.  - FILE_TYPE_ETHASH: File of ethashes  - FILE_TYPE_CONTACT: File of emails and or phone numbers and a contact id for each row  - FILE_TYPE_NPI: File of npis, national health care provider ids
     * @param orgId The ID of the target&#39;s org
     * @param version (OPTIONAL) The version of the target file to download. If empty, the most recent version is returned.
     */
    public advertisingPlatformServiceDownloadTargetFile(targetId?: string, targetFileType?: 'FILE_TYPE_UNKNOWN' | 'FILE_TYPE_ADDRESS' | 'FILE_TYPE_IP' | 'FILE_TYPE_ZIP' | 'FILE_TYPE_DEVICE' | 'FILE_TYPE_GEOJSON' | 'FILE_TYPE_WKB' | 'FILE_TYPE_FILELESS' | 'FILE_TYPE_SOURCE' | 'FILE_TYPE_CLEANED' | 'FILE_TYPE_ETHASH' | 'FILE_TYPE_CONTACT' | 'FILE_TYPE_NPI', orgId?: string, version?: number, _options?: Configuration): Promise<StreamResultOfV2DownloadTargetFileResponse> {
        const result = this.api.advertisingPlatformServiceDownloadTargetFile(targetId, targetFileType, orgId, version, _options);
        return result.toPromise();
    }

    /**
     * #### Description: This endpoint returns the target resource.  ### Unexpected Scenarios: #### 500 (Internal Server Error): - **Action**: Perform a short wait and retry once. - **Exponential Backoff**: If the issue persists, retry using exponential backoff (e.g., 1s, 2s, 4s, 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff with increasing delays (e.g., 1s, 2s, 4s, 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL.  #### TARGET_STATUS_ERRORED: - **Action**: Troubleshoot the request or file for issues (e.g., format, invalid data, etc.). - **Escalation**: If unresolved, submit a support ticket with the target ID and org ID.  ### Exponential Backoff Example: - **Initial Retry**: 1 second - **Subsequent Delays**: 2s, 4s, 8s, 16s, etc., doubling each time. - **Maximum Retry Delay**: Typically capped at 60 seconds for subsequent retries. - **Reset**: After a successful update, the delay resets to the initial 5-second interval for further polling.  By applying this exponential backoff strategy, you ensure more efficient retries, helping to avoid overwhelming the service while allowing time for recovery between requests.  
     * Get Target
     * @param targetId ID of the Target
     * @param orgId The Organization where this Target belongs to.
     */
    public advertisingPlatformServiceGetTarget(targetId: string, orgId: string, _options?: Configuration): Promise<V2Target> {
        const result = this.api.advertisingPlatformServiceGetTarget(targetId, orgId, _options);
        return result.toPromise();
    }

    /**
     * List Target Folders
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListCreatives&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListCreatives&#x60; must match the request that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListTargetFolders(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V2ListTargetFoldersResponse> {
        const result = this.api.advertisingPlatformServiceListTargetFolders(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * List Targets
     * @param pageSize The maximum number of targets to return. The service may return fewer than this value.  If unspecified, at most &#x60;1000&#x60; targets will be returned.  The maximum value is &#x60;1000&#x60;; values above &#x60;1000&#x60; will be coerced to &#x60;1000&#x60;.
     * @param pageToken A page token, received from a previous &#x60;ListTargets&#x60; call. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListTargets&#x60; must match the call that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListTargets(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<V2ListTargetsResponse> {
        const result = this.api.advertisingPlatformServiceListTargets(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * Replace Target File
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceReplaceTargetFile(body: V2ReplaceTargetFileRequest, _options?: Configuration): Promise<V2Target> {
        const result = this.api.advertisingPlatformServiceReplaceTargetFile(body, _options);
        return result.toPromise();
    }

    /**
     * Start Archiving Targets
     */
    public advertisingPlatformServiceStartArchivingTargets(_options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceStartArchivingTargets(_options);
        return result.toPromise();
    }

    /**
     * Unarchive Target
     * @param body 
     */
    public advertisingPlatformServiceUnarchiveTarget(body: V2UnarchiveTargetRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceUnarchiveTarget(body, _options);
        return result.toPromise();
    }

    /**
     * Update Target
     * @param targetId The Target&#39;s ID.
     * @param orgId The Organization where this Target belongs to.
     * @param target The target to update.
     * @param updateMask List of fields to be updated
     */
    public advertisingPlatformServiceUpdateTarget(targetId: string, orgId: string, target: TheTargetToUpdate, updateMask?: string, _options?: Configuration): Promise<V2Target> {
        const result = this.api.advertisingPlatformServiceUpdateTarget(targetId, orgId, target, updateMask, _options);
        return result.toPromise();
    }

    /**
     * ### Description: This endpoint is used for uploading the source file. Once uploaded, the file will undergo processing, and its status will change accordingly.  ---  ### Expected Response: - **Status Code**: 200 or 202 - **Response Body**: Includes the JSON key `'status': 'TARGET_STATUS_SUBMITTED'`, indicating that the target file has been successfully submitted.  ---  ### Unexpected Responses: #### 500 (Internal Server Error): - **Action**: Wait briefly and retry once. - **Exponential Backoff**: If the issue persists after the retry, use an exponential backoff strategy (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro, including the request CURL and file.  #### 503 (Service Unavailable): - **Action**: Retry up to 4 times using exponential backoff with increasing delay (e.g., retry after 1s, 2s, 4s, and 8s). - **Escalation**: If unresolved, submit a support ticket to ElToro with the request CURL and file.  #### Troubleshooting: - **If retries still fail**: Perform basic troubleshooting to check for issues like file format or size. - **Escalation**: If no identifiable issue is found, escalate by submitting a support ticket to ElToro with the request CURL and file.  ---  ### Recommended Polling Strategy: - **Initial Delay**: Start with a 5-second delay between requests. - **Subsequent Delays**: Increase the delay progressively, e.g., 10s, 20s, 40s, up to 60s. - **Reset on Update**: After receiving an update, reset the delay to the initial 5-second interval for further polling.  ---  ### Expected Status Progression: - **TARGET_STATUS_SUBMITTED**: The file is in the submission process. - **TARGET_STATUS_TARGETABLE**: The file is ready for audience creation and generation. - **Other statuses**: May include `TARGET_STATUS_PROCESSING`, `TARGET_STATUS_FAILED`, etc., depending on the file's processing state. 
     * Upload Target File
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadTargetFile(body: V2UploadTargetFileRequest, _options?: Configuration): Promise<V2Target> {
        const result = this.api.advertisingPlatformServiceUploadTargetFile(body, _options);
        return result.toPromise();
    }


}



import { ObservableTermsOfServiceApi } from './ObservableAPI';

import { TermsOfServiceApiRequestFactory, TermsOfServiceApiResponseProcessor} from "../apis/TermsOfServiceApi";
export class PromiseTermsOfServiceApi {
    private api: ObservableTermsOfServiceApi

    public constructor(
        configuration: Configuration,
        requestFactory?: TermsOfServiceApiRequestFactory,
        responseProcessor?: TermsOfServiceApiResponseProcessor
    ) {
        this.api = new ObservableTermsOfServiceApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Download File
     * @param filename Filename  The name of the TOS file.
     * @param orgId Org ID  The id of the org
     * @param userId User ID  The id of the user who signed the file.
     */
    public advertisingPlatformServiceDownloadTOSAgreement(filename?: string, orgId?: string, userId?: string, _options?: Configuration): Promise<StreamResultOfV1DownloadTOSAgreementResponse> {
        const result = this.api.advertisingPlatformServiceDownloadTOSAgreement(filename, orgId, userId, _options);
        return result.toPromise();
    }

    /**
     * Get user's IP address
     */
    public advertisingPlatformServiceGetUserIPAddress(_options?: Configuration): Promise<V1GetUserIPResponse> {
        const result = this.api.advertisingPlatformServiceGetUserIPAddress(_options);
        return result.toPromise();
    }

    /**
     * Upload TOS Agreement
     * @param orgId Org ID  The id of the org
     * @param userId User ID  The id of the user who signed the file.
     */
    public advertisingPlatformServiceListTOSAgreements(orgId?: string, userId?: string, _options?: Configuration): Promise<V1ListTOSAgreementsResponse> {
        const result = this.api.advertisingPlatformServiceListTOSAgreements(orgId, userId, _options);
        return result.toPromise();
    }

    /**
     * Upload TOS Agreement
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadTOSAgreement(body: V1UploadTOSAgreementRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceUploadTOSAgreement(body, _options);
        return result.toPromise();
    }


}



import { ObservableUsersApi } from './ObservableAPI';

import { UsersApiRequestFactory, UsersApiResponseProcessor} from "../apis/UsersApi";
export class PromiseUsersApi {
    private api: ObservableUsersApi

    public constructor(
        configuration: Configuration,
        requestFactory?: UsersApiRequestFactory,
        responseProcessor?: UsersApiResponseProcessor
    ) {
        this.api = new ObservableUsersApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param user 
     */
    public advertisingPlatformServiceCreateUser(user: Hagridv1User, _options?: Configuration): Promise<Hagridv1User> {
        const result = this.api.advertisingPlatformServiceCreateUser(user, _options);
        return result.toPromise();
    }

    /**
     * @param id ID of a User
     */
    public advertisingPlatformServiceDeleteUser(id: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteUser(id, _options);
        return result.toPromise();
    }

    /**
     * @param userId ID of a User
     */
    public advertisingPlatformServiceGetUser(userId: string, _options?: Configuration): Promise<Hagridv1User> {
        const result = this.api.advertisingPlatformServiceGetUser(userId, _options);
        return result.toPromise();
    }

    /**
     * @param pageSize The maximum number of resources to return. The service may return fewer than this value. If unspecified, at most 16 resources will be returned. The maximum value is 100; values above 100 will be coerced to 100.
     * @param pageToken A page token, received from a previous &#x60;ListOrgs&#x60; request. Provide this to retrieve the subsequent page.  When paginating, all other parameters provided to &#x60;ListOrgs&#x60; must match the request that provided the page token.
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     * @param email Email of a User. This is not required. Only use this if you want to get one user by their email
     */
    public advertisingPlatformServiceListUsers(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, email?: string, _options?: Configuration): Promise<Hagridv1ListUsersResponse> {
        const result = this.api.advertisingPlatformServiceListUsers(pageSize, pageToken, orderBy, filter, email, _options);
        return result.toPromise();
    }

    /**
     * List users
     * @param pageSize 
     * @param pageToken 
     * @param orderBy Sort order as described here https://google.aip.dev/132#ordering.
     * @param filter Filtering as described here https://google.aip.dev/160.
     */
    public advertisingPlatformServiceListUsersV2(pageSize?: number, pageToken?: string, orderBy?: string, filter?: string, _options?: Configuration): Promise<Orgmanagerv2ListUsersResponse> {
        const result = this.api.advertisingPlatformServiceListUsersV2(pageSize, pageToken, orderBy, filter, _options);
        return result.toPromise();
    }

    /**
     * @param userId ID of a User
     * @param user Existing user with new field values
     * @param updateMask Indicates which user fields to update
     */
    public advertisingPlatformServiceUpdateUser(userId: string, user: ExistingUserWithNewFieldValues, updateMask?: string, _options?: Configuration): Promise<Hagridv1User> {
        const result = this.api.advertisingPlatformServiceUpdateUser(userId, user, updateMask, _options);
        return result.toPromise();
    }


}



import { ObservableWebToHomeApi } from './ObservableAPI';

import { WebToHomeApiRequestFactory, WebToHomeApiResponseProcessor} from "../apis/WebToHomeApi";
export class PromiseWebToHomeApi {
    private api: ObservableWebToHomeApi

    public constructor(
        configuration: Configuration,
        requestFactory?: WebToHomeApiRequestFactory,
        responseProcessor?: WebToHomeApiResponseProcessor
    ) {
        this.api = new ObservableWebToHomeApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Attach an org-owned address-exclusion file to a subscription (subscription_id set) or to a pixel (pixel_id only)
     * Attach an org-owned address-exclusion file to a subscription or a pixel
     * @param body 
     */
    public advertisingPlatformServiceAttachExcludedAddresses(body: V1AttachExcludedAddressesRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceAttachExcludedAddresses(body, _options);
        return result.toPromise();
    }

    /**
     * Create a ftp in pixel
     * Create an FTP
     * @param publisherId 
     * @param ftp 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateFTP(publisherId: string, ftp: V1FTP, orgId?: string, _options?: Configuration): Promise<V1FTP> {
        const result = this.api.advertisingPlatformServiceCreateFTP(publisherId, ftp, orgId, _options);
        return result.toPromise();
    }

    /**
     * Create a pixel in pixel
     * Create a Pixel
     * @param pixel 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePixel(pixel: V1Pixel, orgId?: string, _options?: Configuration): Promise<V1Pixel> {
        const result = this.api.advertisingPlatformServiceCreatePixel(pixel, orgId, _options);
        return result.toPromise();
    }

    /**
     * Create Pixel's Note
     * @param pixelId 
     * @param note 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePixelNote(pixelId: string, note: V1PixelNote, orgId?: string, _options?: Configuration): Promise<V1PixelNote> {
        const result = this.api.advertisingPlatformServiceCreatePixelNote(pixelId, note, orgId, _options);
        return result.toPromise();
    }

    /**
     * Create a publisher in pixel
     * Create a Publisher
     * @param publisher 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePublisher(publisher: V1Publisher, orgId?: string, _options?: Configuration): Promise<V1Publisher> {
        const result = this.api.advertisingPlatformServiceCreatePublisher(publisher, orgId, _options);
        return result.toPromise();
    }

    /**
     * Create a rule in pixel
     * Create an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param rule 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateRule(pixelId: string, subscriptionId: string, ruleSetId: string, rule: V1Rule, orgId?: string, _options?: Configuration): Promise<V1Rule> {
        const result = this.api.advertisingPlatformServiceCreateRule(pixelId, subscriptionId, ruleSetId, rule, orgId, _options);
        return result.toPromise();
    }

    /**
     * Create a rule_set in pixel
     * Create an RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSet 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateRuleSet(pixelId: string, subscriptionId: string, ruleSet: V1RuleSet, orgId?: string, _options?: Configuration): Promise<V1RuleSet> {
        const result = this.api.advertisingPlatformServiceCreateRuleSet(pixelId, subscriptionId, ruleSet, orgId, _options);
        return result.toPromise();
    }

    /**
     * Create a subscription in pixel
     * Create a Subscription
     * @param pixelId 
     * @param subscription 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateSubscription(pixelId: string, subscription: V1Subscription, orgId?: string, _options?: Configuration): Promise<V1Subscription> {
        const result = this.api.advertisingPlatformServiceCreateSubscription(pixelId, subscription, orgId, _options);
        return result.toPromise();
    }

    /**
     * Create Subscription's Note
     * @param pixelId 
     * @param subscriptionId 
     * @param note 
     * @param orgId 
     */
    public advertisingPlatformServiceCreateSubscriptionNote(pixelId: string, subscriptionId: string, note: V1SubscriptionNote, orgId?: string, _options?: Configuration): Promise<V1SubscriptionNote> {
        const result = this.api.advertisingPlatformServiceCreateSubscriptionNote(pixelId, subscriptionId, note, orgId, _options);
        return result.toPromise();
    }

    /**
     * Hard-delete an org-owned address-exclusion file
     * Hard-delete an org-owned address-exclusion file (admin only)
     * @param fileId 
     */
    public advertisingPlatformServiceDeleteExclusionAddresses(fileId: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteExclusionAddresses(fileId, _options);
        return result.toPromise();
    }

    /**
     * Delete an ftp in pixel
     * Delete an FTP
     * @param publisherId 
     * @param ftpId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteFTP(publisherId: string, ftpId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteFTP(publisherId, ftpId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete a pixel in pixel
     * Delete a Pixel
     * @param pixelId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePixel(pixelId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeletePixel(pixelId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete a Pixel's Note
     * Delete a PixelNote
     * @param pixelId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePixelNote(pixelId: string, noteId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeletePixelNote(pixelId, noteId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete a publisher in pixel
     * Delete a Publisher
     * @param publisherId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePublisher(publisherId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeletePublisher(publisherId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete an rule in pixel
     * Delete an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param ruleId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteRule(pixelId: string, subscriptionId: string, ruleSetId: string, ruleId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteRule(pixelId, subscriptionId, ruleSetId, ruleId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete an rule_set in pixel
     * Delete an RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteRuleSet(pixelId: string, subscriptionId: string, ruleSetId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteRuleSet(pixelId, subscriptionId, ruleSetId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete a subscription in pixel
     * Delete a Subscription
     * @param pixelId 
     * @param subscriptionId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteSubscription(pixelId: string, subscriptionId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteSubscription(pixelId, subscriptionId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete a Subscription's Note
     * Delete a SubscriptionNote
     * @param pixelId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeleteSubscriptionNote(pixelId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeleteSubscriptionNote(pixelId, subscriptionId, noteId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Detach an org-owned address-exclusion file from a subscription or a pixel
     * Detach an org-owned address-exclusion file from a subscription or a pixel
     * @param body 
     */
    public advertisingPlatformServiceDetachExcludedAddresses(body: V1DetachExcludedAddressesRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDetachExcludedAddresses(body, _options);
        return result.toPromise();
    }

    /**
     * Download an org-owned address-exclusion file by id as text/csv. `org_id` is a required query parameter.
     * Download Exclusion Addresses
     * @param fileId 
     * @param orgId 
     */
    public advertisingPlatformServiceDownloadExclusionAddresses(fileId: string, orgId?: string, _options?: Configuration): Promise<StreamResultOfV1DownloadExclusionAddressesResponse> {
        const result = this.api.advertisingPlatformServiceDownloadExclusionAddresses(fileId, orgId, _options);
        return result.toPromise();
    }

    /**
     * List all ftps associated with a publisher
     * Get FTP
     * @param publisherId 
     * @param ftpId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetFTP(publisherId: string, ftpId: string, orgId?: string, _options?: Configuration): Promise<V1FTP> {
        const result = this.api.advertisingPlatformServiceGetFTP(publisherId, ftpId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get an org's pixels
     * Get a Pixel
     * @param pixelId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPixel(pixelId: string, orgId?: string, _options?: Configuration): Promise<V1Pixel> {
        const result = this.api.advertisingPlatformServiceGetPixel(pixelId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a note made on the subscription by a publisher. This is a restricted endpoint and only available to print partners 
     * Get a PixelNote
     * @param pixelId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPixelNote(pixelId: string, noteId: string, orgId?: string, _options?: Configuration): Promise<V1PixelNote> {
        const result = this.api.advertisingPlatformServiceGetPixelNote(pixelId, noteId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a publisher in pixel
     * Get a Publisher
     * @param publisherId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPublisher(publisherId: string, orgId?: string, _options?: Configuration): Promise<V1Publisher> {
        const result = this.api.advertisingPlatformServiceGetPublisher(publisherId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a rule in pixel
     * Get an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param ruleId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetRule(pixelId: string, subscriptionId: string, ruleSetId: string, ruleId: string, orgId?: string, _options?: Configuration): Promise<V1Rule> {
        const result = this.api.advertisingPlatformServiceGetRule(pixelId, subscriptionId, ruleSetId, ruleId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a rule set in pixel
     * Get a RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetRuleSet(pixelId: string, subscriptionId: string, ruleSetId: string, orgId?: string, _options?: Configuration): Promise<V1RuleSet> {
        const result = this.api.advertisingPlatformServiceGetRuleSet(pixelId, subscriptionId, ruleSetId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a subscription in pixel
     * Get a Subscription
     * @param pixelId 
     * @param subscriptionId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetSubscription(pixelId: string, subscriptionId: string, orgId?: string, _options?: Configuration): Promise<V1Subscription> {
        const result = this.api.advertisingPlatformServiceGetSubscription(pixelId, subscriptionId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a note made on the subscription by a publisher. This is a restricted endpoint and only available to print partners 
     * Get a SubscriptionNote
     * @param pixelId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetSubscriptionNote(pixelId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Promise<V1SubscriptionNote> {
        const result = this.api.advertisingPlatformServiceGetSubscriptionNote(pixelId, subscriptionId, noteId, orgId, _options);
        return result.toPromise();
    }

    /**
     * List the org-owned address-exclusion files for an org
     * List an org's address-exclusion files
     * @param orgId 
     */
    public advertisingPlatformServiceListExclusionAddresses(orgId?: string, _options?: Configuration): Promise<V1ListExclusionAddressesResponse> {
        const result = this.api.advertisingPlatformServiceListExclusionAddresses(orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a subscription in pixel
     * Get all subscriptions for an org
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     * @param id 
     * @param name 
     * @param pixelId 
     * @param pixelName 
     * @param tags 
     */
    public advertisingPlatformServiceListOrgSubscriptions(pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, id?: string, name?: string, pixelId?: string, pixelName?: string, tags?: Array<string>, _options?: Configuration): Promise<V1ListOrgSubscriptionsResponse> {
        const result = this.api.advertisingPlatformServiceListOrgSubscriptions(pageSize, pageToken, orgId, orderBy, id, name, pixelId, pixelName, tags, _options);
        return result.toPromise();
    }

    /**
     * List an org's pixels
     * List Pixels
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     * @param id 
     * @param name 
     * @param tags 
     */
    public advertisingPlatformServiceListPixels(pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, id?: string, name?: string, tags?: Array<string>, _options?: Configuration): Promise<V1ListPixelsResponse> {
        const result = this.api.advertisingPlatformServiceListPixels(pageSize, pageToken, orgId, orderBy, id, name, tags, _options);
        return result.toPromise();
    }

    /**
     * Get a publisher in pixel
     * List all Publishers
     * @param pageSize 
     * @param pageToken 
     * @param orderBy 
     * @param orgId 
     */
    public advertisingPlatformServiceListPublishers(pageSize?: number, pageToken?: string, orderBy?: string, orgId?: string, _options?: Configuration): Promise<V1ListPublishersResponse> {
        const result = this.api.advertisingPlatformServiceListPublishers(pageSize, pageToken, orderBy, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a rule in pixel
     * List Rules
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orderBy 
     * @param orgId 
     */
    public advertisingPlatformServiceListRules(pixelId: string, subscriptionId: string, ruleSetId: string, pageSize?: number, pageToken?: string, orderBy?: string, orgId?: string, _options?: Configuration): Promise<V1ListRulesResponse> {
        const result = this.api.advertisingPlatformServiceListRules(pixelId, subscriptionId, ruleSetId, pageSize, pageToken, orderBy, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get all stats on a subscription or filter by the run date. returns in most recently ran order
     * List Subscription Stats
     * @param pixelId 
     * @param subscriptionId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param startReportDate 
     * @param endReportDate 
     * @param orderBy 
     * @param returnDuplicates 
     */
    public advertisingPlatformServiceListStats(pixelId: string, subscriptionId: string, pageSize?: number, pageToken?: string, orgId?: string, startReportDate?: string, endReportDate?: string, orderBy?: string, returnDuplicates?: boolean, _options?: Configuration): Promise<V1ListStatsResponse> {
        const result = this.api.advertisingPlatformServiceListStats(pixelId, subscriptionId, pageSize, pageToken, orgId, startReportDate, endReportDate, orderBy, returnDuplicates, _options);
        return result.toPromise();
    }

    /**
     * Get a subscription in pixel
     * List Subscriptions
     * @param pixelId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     */
    public advertisingPlatformServiceListSubscriptions(pixelId: string, pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, _options?: Configuration): Promise<V1ListSubscriptionsResponse> {
        const result = this.api.advertisingPlatformServiceListSubscriptions(pixelId, pageSize, pageToken, orgId, orderBy, _options);
        return result.toPromise();
    }

    /**
     * Get stats. returns in most recently ran order
     * List Stats
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param publisherId 
     * @param pixelId 
     * @param subscriptionId 
     * @param startReportDate 
     * @param endReportDate 
     * @param orderBy 
     * @param returnDuplicates 
     */
    public advertisingPlatformServiceListTotalStats(pageSize?: number, pageToken?: string, orgId?: string, publisherId?: string, pixelId?: string, subscriptionId?: string, startReportDate?: string, endReportDate?: string, orderBy?: string, returnDuplicates?: boolean, _options?: Configuration): Promise<V1ListTotalStatsResponse> {
        const result = this.api.advertisingPlatformServiceListTotalStats(pageSize, pageToken, orgId, publisherId, pixelId, subscriptionId, startReportDate, endReportDate, orderBy, returnDuplicates, _options);
        return result.toPromise();
    }

    /**
     * Run all subscriptions in pixel
     * Get all Subscriptions
     * @param reportDate 
     */
    public advertisingPlatformServiceRunAllSubscriptions(reportDate?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceRunAllSubscriptions(reportDate, _options);
        return result.toPromise();
    }

    /**
     * Run all subscriptions in pixel
     * Get a Subscription
     * @param pixelId 
     * @param subscriptionId 
     * @param body 
     */
    public advertisingPlatformServiceRunOneSubscription(pixelId: string, subscriptionId: string, body: AdvertisingPlatformServiceRunOneSubscriptionRequest, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceRunOneSubscription(pixelId, subscriptionId, body, _options);
        return result.toPromise();
    }

    /**
     * Update an ftp in pixel
     * Update an FTP
     * @param publisherId 
     * @param ftpId Id of the ftp server
     * @param ftp 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateFTP(publisherId: string, ftpId: string, ftp: AdvertisingPlatformServiceUpdateFTPRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1FTP> {
        const result = this.api.advertisingPlatformServiceUpdateFTP(publisherId, ftpId, ftp, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Update a pixel in pixel
     * Update a Pixel
     * @param pixelId Id of the pixel
     * @param pixel 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePixel(pixelId: string, pixel: AdvertisingPlatformServiceUpdatePixelRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1Pixel> {
        const result = this.api.advertisingPlatformServiceUpdatePixel(pixelId, pixel, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Update Pixel's Note
     * @param pixelId 
     * @param noteId The Note ID.
     * @param note PixelNote
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePixelNote(pixelId: string, noteId: string, note: PixelNote, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1PixelNote> {
        const result = this.api.advertisingPlatformServiceUpdatePixelNote(pixelId, noteId, note, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Update a publisher in pixel
     * Update a Publisher
     * @param publisherId Id of the publisher
     * @param publisher 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePublisher(publisherId: string, publisher: AdvertisingPlatformServiceUpdatePublisherRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1Publisher> {
        const result = this.api.advertisingPlatformServiceUpdatePublisher(publisherId, publisher, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Update a rule in pixel
     * Update an Rule
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId 
     * @param ruleId Id of the ruleset
     * @param rule 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateRule(pixelId: string, subscriptionId: string, ruleSetId: string, ruleId: string, rule: AdvertisingPlatformServiceUpdateRuleRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1Rule> {
        const result = this.api.advertisingPlatformServiceUpdateRule(pixelId, subscriptionId, ruleSetId, ruleId, rule, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Update a rule set in pixel
     * Update an RuleSet
     * @param pixelId 
     * @param subscriptionId 
     * @param ruleSetId Id of the ruleset
     * @param ruleSet 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateRuleSet(pixelId: string, subscriptionId: string, ruleSetId: string, ruleSet: AdvertisingPlatformServiceUpdateRuleSetRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1RuleSet> {
        const result = this.api.advertisingPlatformServiceUpdateRuleSet(pixelId, subscriptionId, ruleSetId, ruleSet, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Update a subscription in pixel
     * Update a Subscription
     * @param pixelId 
     * @param subscriptionId Id of the subscription
     * @param subscription 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateSubscription(pixelId: string, subscriptionId: string, subscription: AdvertisingPlatformServiceUpdateSubscriptionRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1Subscription> {
        const result = this.api.advertisingPlatformServiceUpdateSubscription(pixelId, subscriptionId, subscription, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Update Subscription's Note
     * @param pixelId 
     * @param subscriptionId 
     * @param noteId The Note ID.
     * @param note SubscriptionNote
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdateSubscriptionNote(pixelId: string, subscriptionId: string, noteId: string, note: SubscriptionNote, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1SubscriptionNote> {
        const result = this.api.advertisingPlatformServiceUpdateSubscriptionNote(pixelId, subscriptionId, noteId, note, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Upload a raw address CSV (multipart/form-data, field `file`) as a new org-owned address-exclusion file. The CSV header must be exactly `address1,address2,city,state,zip`. `org_id` is a required query parameter. Returns 202 Accepted; the raw file is staged to S3 and a geocode workflow runs asynchronously, later populating `s3_url`. Associate the file with a subscription via the `:attach` endpoint.
     * Upload Exclusion Addresses
     * @param body  (streaming inputs)
     */
    public advertisingPlatformServiceUploadExclusionAddresses(body: V1UploadExclusionAddressesRequest, _options?: Configuration): Promise<V1ExclusionAddresses> {
        const result = this.api.advertisingPlatformServiceUploadExclusionAddresses(body, _options);
        return result.toPromise();
    }


}



import { ObservableWebToHomePrintPartnerOnlyApi } from './ObservableAPI';

import { WebToHomePrintPartnerOnlyApiRequestFactory, WebToHomePrintPartnerOnlyApiResponseProcessor} from "../apis/WebToHomePrintPartnerOnlyApi";
export class PromiseWebToHomePrintPartnerOnlyApi {
    private api: ObservableWebToHomePrintPartnerOnlyApi

    public constructor(
        configuration: Configuration,
        requestFactory?: WebToHomePrintPartnerOnlyApiRequestFactory,
        responseProcessor?: WebToHomePrintPartnerOnlyApiResponseProcessor
    ) {
        this.api = new ObservableWebToHomePrintPartnerOnlyApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Subscriptions - Notes - Create
     * @param publisherId 
     * @param subscriptionId 
     * @param note 
     * @param orgId 
     */
    public advertisingPlatformServiceCreatePublisherSubscriptionNote(publisherId: string, subscriptionId: string, note: V1SubscriptionNote, orgId?: string, _options?: Configuration): Promise<V1SubscriptionNote> {
        const result = this.api.advertisingPlatformServiceCreatePublisherSubscriptionNote(publisherId, subscriptionId, note, orgId, _options);
        return result.toPromise();
    }

    /**
     * Delete a Subscription Note
     * Subscriptions - Notes - Delete
     * @param publisherId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceDeletePublisherSubscriptionNote(publisherId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Promise<any> {
        const result = this.api.advertisingPlatformServiceDeletePublisherSubscriptionNote(publisherId, subscriptionId, noteId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a subscription in which the user/org is the print partner. This is a restricted endpoint and only available to print partners Only the fields the print partner has access to view are returned. 
     * Subscriptions - Get
     * @param publisherId 
     * @param subscriptionId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPublisherSubscription(publisherId: string, subscriptionId: string, orgId?: string, _options?: Configuration): Promise<V1PublisherSubscription> {
        const result = this.api.advertisingPlatformServiceGetPublisherSubscription(publisherId, subscriptionId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get a note made on the subscription. This is a restricted endpoint and only available to print partners 
     * Subscriptions - Notes - Get
     * @param publisherId 
     * @param subscriptionId 
     * @param noteId 
     * @param orgId 
     */
    public advertisingPlatformServiceGetPublisherSubscriptionNote(publisherId: string, subscriptionId: string, noteId: string, orgId?: string, _options?: Configuration): Promise<V1SubscriptionNote> {
        const result = this.api.advertisingPlatformServiceGetPublisherSubscriptionNote(publisherId, subscriptionId, noteId, orgId, _options);
        return result.toPromise();
    }

    /**
     * Get all stats on a subscription or filter by the run date. returns in most recently ran order This is a restricted endpoint and only available to print partners Only the stats for subscriptions the user/org is the print partner can be accessed. The only valid filters to use fight now are start_report_date and end_report_date. These are formatted as strings. If you pass start_report_date but not end_report_date, you will get all stats for runs after start_report_date. If you pass start_report_date and end_report_date, you will get all stats for runs after start_report_date and before the end_report_date. If you pass only the end_report_date, you will get all stats for runs that occurred before the end_report_date. 
     * Subscriptions - Stats - List
     * @param publisherId 
     * @param subscriptionId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param startReportDate 
     * @param endReportDate 
     * @param orderBy 
     * @param returnDuplicates 
     */
    public advertisingPlatformServiceListPublisherSubscriptionStats(publisherId: string, subscriptionId: string, pageSize?: number, pageToken?: string, orgId?: string, startReportDate?: string, endReportDate?: string, orderBy?: string, returnDuplicates?: boolean, _options?: Configuration): Promise<V1ListStatsResponse> {
        const result = this.api.advertisingPlatformServiceListPublisherSubscriptionStats(publisherId, subscriptionId, pageSize, pageToken, orgId, startReportDate, endReportDate, orderBy, returnDuplicates, _options);
        return result.toPromise();
    }

    /**
     * List all the subscriptions in which the user/org is the print partner  This is a restricted endpoint and only available to print partners Only the fields the print partner has access to view are returned. 
     * Subscriptions - List
     * @param publisherId 
     * @param pageSize The maximum number of items to return.
     * @param pageToken 
     * @param orgId 
     * @param orderBy 
     * @param name 
     * @param id 
     * @param tags 
     */
    public advertisingPlatformServiceListPublisherSubscriptions(publisherId: string, pageSize?: number, pageToken?: string, orgId?: string, orderBy?: string, name?: string, id?: string, tags?: Array<string>, _options?: Configuration): Promise<V1ListPublisherSubscriptionsResponse> {
        const result = this.api.advertisingPlatformServiceListPublisherSubscriptions(publisherId, pageSize, pageToken, orgId, orderBy, name, id, tags, _options);
        return result.toPromise();
    }

    /**
     * Update a subscription in pixel which the user/org is the print partner  This is a restricted endpoint and only available to print partners Only the fields the print partner can update are: enabled and ftp_path. notes can be managed via the notes endpoint.  
     * Subscriptions - Update
     * @param publisherId 
     * @param subscriptionId 
     * @param subscription 
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePublisherSubscription(publisherId: string, subscriptionId: string, subscription: AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1PublisherSubscription> {
        const result = this.api.advertisingPlatformServiceUpdatePublisherSubscription(publisherId, subscriptionId, subscription, updateMask, orgId, _options);
        return result.toPromise();
    }

    /**
     * Subscriptions - Notes - Update
     * @param publisherId 
     * @param subscriptionId 
     * @param noteId The Note ID.
     * @param note SubscriptionNote
     * @param updateMask 
     * @param orgId 
     */
    public advertisingPlatformServiceUpdatePublisherSubscriptionNote(publisherId: string, subscriptionId: string, noteId: string, note: SubscriptionNote, updateMask?: string, orgId?: string, _options?: Configuration): Promise<V1SubscriptionNote> {
        const result = this.api.advertisingPlatformServiceUpdatePublisherSubscriptionNote(publisherId, subscriptionId, noteId, note, updateMask, orgId, _options);
        return result.toPromise();
    }


}



